import {Injectable} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Constant, PlatFormType} from "src/app/common/constant/constant";

@Injectable({
    providedIn: "root",
})
export class ApiService {
    public multipleShops: boolean = false;
    public totalPayInvoice: any = '';
    public wdTotalPayInvoice: any = '';
    public priorityDropdown: boolean = false;
    public backtoThreadID: string = '';
    public similarThreadID: string = '';
    public similarThreadFlag: string = '0';
    public recentTapSelected: boolean = false;
    public similarTabCall: boolean = false;
    public similarThreadCount: number = 0;
    public similarTechInfoCount: number = 0;
    public similarSIBCount: number = 0;
    public similarEmpty: boolean = true;
    public salesDeWid: number = 0;
    public salesDeWidFlag: boolean = false;
    public salesDashboardFlag: boolean = false;
    public salesDashboardShowPage: boolean = false;
    public commentUpdateFlag: boolean = false;
    public commentUpdatedFlag: boolean = false;
    public replyUpdateFlag: boolean = false;
    public replyUpdatedFlag: boolean = false;
    public gtsid: string = '';
    public loadACXLoadEvent: boolean = false;
    public loadACXPageValue1: string = '';
    public loadACXPageValue2: string = '';
    public loadACXPageValue3: string = '';
    public showBestMatchAllowDomain: boolean = true;
    public partsCategoryEnabled: boolean = false;
    public partsCategory: boolean = false;
    public partsCategoryId: string = '';
    public partsCategoryName: string = '';
    public exactMatch: boolean = false;
    public multipleAccount: boolean = false;
    public cbaDomainDisclimerFlag: boolean = false;
    public reason: boolean = false;
    public redline: boolean = false;
    public sibServiceCallFlag: string = '1';
    public kiaDealerName: string = '';
    public kiaDealerCode: string = '';
    public kiaUserName: string = '';
    public exportAction: string = '1';
    public blackTheameModule: boolean = false;
    public llmSummary: string = "";
    public threadListView: string = '1';
    public jobandratecardNewButton: boolean = false;
    public repairOrderPublicPage: boolean = false;
    public isPublicFormPage: boolean = false;
    public threadViewPublicPage: boolean = false;
    public docViewPublicPage: boolean = false;
    public kaViewPublicPage: boolean = false;
    public repairOrderPublicDomainId: string = '338';
    public threadViewPublicDomainId: string = '';
    public docViewPublicDomainId: string = '';
    public kaViewPublicDomainId: string = '';
    public isPublicFormDomainId: string = '366';
    public repairOrderPublicUserId: string = '4440';
    public threadViewPublicUserId: string = '';
    public docViewPublicUserId: string = '';
    public kaViewPublicUserId: string = '';
    public isPublicFormUserId: string = '';
    public techSupportFlagServer: boolean = false;
    public domainMembersShowFlag: boolean = false;
    public newupdateRefresh: boolean = false;
    public upgradePopupShow: string = "";
    public techsupportNewButton: boolean = false;
    public webUpdatesArray = [];
    public attachmentLinkError: string = "";
    public attachmentNewPOPUP: boolean = false;
    public mediaApplyCall: boolean = false;
    public searchFromPageNameClose: boolean = false;
    public searchPageRedirectFlag: string = "0";
    public searchPageDocRedirectFlag: string = "0";
    public searchPageDocPageRedirectFlag: string = "0";
    public searchPagePartRedirectFlag: string = "0";
    public searchPagePartPageRedirectFlag: string = "0";
    public searchPageKARedirectFlag: string = "0";
    public knowledgeArtCall: string = "0";
    public searchFromWorkstream: boolean = false;
    public searchFromWorkstreamValue: string = '';
    public kaCategory: boolean = false;
    public uploadURL: string;
    public userName: string = "";
    public profileImage: string = "";
    public LastLogin: string = "";
    public userRole: string = "";
    public expiredSubscription: boolean = false;
    public subscriptionInfo: any;
    public subscribedProduct: any;
    public newThreadAccessLevel: number = 0 // accessLevel
    public enableAccessLevel: boolean = false // accessLevel
    public enableJobRateAccessLevel: boolean = false // accessLevel
    public roleMapPublishbutton: boolean = false // rolemap
    // Thread Detail
    public checkDiscard: boolean = false;
    public postButtonEnable: boolean = false;
    public postReplyButtonEnable: boolean = false;
    public postSaveButtonEnable: boolean = false;
    public postEditButtonEnable: boolean = false;
    public postEditReplyButtonEnable: boolean = false;
    public uploadCommentFlag: boolean = false;
    public tagCommentFlag: boolean = false;
    public uploadReplyFlag: boolean = false;
    public tagReplyFlag: boolean = false;

    public collabticApi: string;
    public collabticV3Api: string;
    public collabticV3ApiV2: string;
    public mahleV2Api: string;
    public collabticForumApi: string;
    public collabticLandingApi: string;

    public reviewApi: string;
    public collabticDashApi: string;
    public mahleV2DashApi: string;
    public collabticProbingApi: string;
    public collabticVehicleApi: string;
    public collabticGTSApi: string;
    public collabticAccountsApi: string;
    public collabticAccountsApiv2: string;

    public productInfoApi: string;
    public escalationV2Api: string;
    public productmakeApi: string;
    public partsApi: string;
    public knowledgeBaseApi: string;
    public knowledgeArticleApi: string;
    public resourceApi: string;
    public searchApi: string;
    public uploadApi: string;
    public mediaApi: string;
    public mediaUploadApi: string;
    public testApi: string;
    public vimeoApi: string;
    public notificationApi: string;
    public pushApi: string;
    public threadPostApi: string;
    public threadPostApi2: string;
    public langApi: string;
    public platformInfo = localStorage.getItem("platformId");
    public demoGtsMahale: string = Constant.TechproMahleApi;
    public jobStatusApi: string;
    public modalapi: string;
    public serviceProviderApi: string;
    public kaizenApi: string;
    public platformIdInfo = localStorage.getItem("platformId");
    public collabticLocalhost: string = Constant.collabticV3ApiUrl;
    public supportApi: string;

    //public collabticLocalhost: string = Constant.collabticV3ApiUrl;

    constructor(private router: Router, private route: ActivatedRoute) {
        let platformId = localStorage.getItem("platformId");
        if (platformId == null || platformId == 'null') {
            // platformId = PlatFormType.Collabtic;
            //platformId=PlatFormType.MahleForum;
            platformId=PlatFormType.CbaForum;
        }
        this.collabticV3Api = Constant.collabticV3ApiUrl;
        this.collabticV3ApiV2 = Constant.collabticV3ApiUrlV2;

        if (platformId == PlatFormType.Collabtic) {
            let domainId = localStorage.getItem('domainId');
            // alert(window.location.host);
            // if(domainId=='336' ||  window.location.host=='collabticfixes.collabtic.com' || window.location.host=='localhost:4200' || window.location.host=='forum-dev-stage-collabtic.collabtic.com' || window.location.host=='forum-dev-fixes-collabtic.collabtic.com' )
            // if(domainId=='336' || window.location.host=='forum-dev-solr-collabtic.collabtic.com')
            if (domainId == '336' || window.location.host == 'collabticfixes.collabtic.com' || window.location.host == 'forum-dev-fixes-collabtic.collabtic.com') {
                this.collabticV3Api = Constant.collabticFixesV3ApiUrl;
                this.collabticApi = Constant.CollabticFixesApiUrl;
                this.collabticLocalhost = Constant.collabticFixesV3ApiUrl;
            } else {
                this.collabticApi = Constant.CollabticApiUrl;
            }
            this.partsCategoryEnabled = true;
            this.enableAccessLevel = true; // Roles and Permission - Access Level Enabled
        } else if (platformId == PlatFormType.MahleForum) {
            this.collabticApi = Constant.TechproMahleApi;
            this.mahleV2Api = Constant.TechproMahleV2Api;
            this.enableAccessLevel = true; // Roles and Permission - Access Level Enabled
        } else if (platformId == PlatFormType.CbaForum) {
            this.collabticApi = Constant.CbaApiUri;
            this.collabticV3Api = Constant.CbaV3ApiUri;
            this.enableAccessLevel = true; // Roles and Permission - Access Level Enabled
        } else if (platformId == PlatFormType.KiaForum) {
            this.collabticApi = Constant.KiaApiUri;
        } else {
            this.collabticApi = Constant.CollabticApiUrl;
        }


        // set upload url for ckeditor
        this.uploadURL = `${this.collabticApi}/accounts/UploadAttachtoSvr`;

        //this.collabticApi = Constant.TechproMahleApi;
        this.collabticForumApi = `${this.collabticApi}/forum`;
        this.collabticLandingApi = `${this.collabticApi}/Landingpage`;
        this.collabticDashApi = `${this.collabticApi}/dashboard`;
        this.mahleV2DashApi = `${this.mahleV2Api}/dashboard`;
        this.productInfoApi = `${this.collabticApi}/Productmatrix`;
        this.escalationV2Api = `${this.collabticApi}/Escalation`;
        this.partsApi = `${this.collabticApi}/parts`;
        this.knowledgeBaseApi = `${this.collabticApi}/knowledgebase`;
        this.knowledgeArticleApi = `${this.collabticApi}/softwaredl`;
        this.resourceApi = `${this.collabticApi}/resources`;
        this.searchApi = `${this.collabticApi}/search`;
        this.productmakeApi = `${this.collabticApi}/vehicle`;
        this.collabticAccountsApi = `${this.collabticApi}/accounts`;
        this.collabticAccountsApiv2 = `${this.collabticV3Api}/accounts`;

        this.kaizenApi = `${this.collabticApi}/kaizen`;
        this.serviceProviderApi = Constant.serviceProviderApi;
        this.supportApi = `${this.collabticApi}/support`;
        //this.uploadApi = `${this.collabticApi}/threadpost/AttachmentUploadNew`;

        if (this.platformInfo != "1") {
            this.uploadApi = `${this.collabticApi}/threadpost/AttachmentUpload`;
        } else {
            this.uploadApi = `${this.collabticApi}/threadpost/AttachmentUploadV2`;
        }
        this.mediaApi = `${this.collabticApi}/media`;
        //this.mediaUploadApi = `${this.mediaApi}/UpdateandUploadattachments`;
        this.modalapi = `${this.collabticApi}/productmatrix`;

        //this.mediaUploadApi = `${this.collabticApi}/threadpost/AttachmentUpload`;
        if (this.platformInfo != "1") {
            this.mediaUploadApi = `${this.collabticApi}/threadpost/AttachmentUpload`;
        } else {
            this.mediaUploadApi = `${this.collabticApi}/threadpost/AttachmentUploadV2`;
        }
        this.vimeoApi = "http://vimeo.com/api/v2/video";
        this.notificationApi = `${this.collabticApi}/forumnewversion`;
        this.pushApi = `${this.collabticApi}/push`;
        // this.threadPostApi = `${this.collabticApi}/threadpost/ChatFileUploadV2`;

        this.threadPostApi2 = `${this.collabticApi}/threadpost/`;
        this.langApi = `${this.resourceApi}/getLangUageList`;

        if (this.platformInfo != "1") {
            this.threadPostApi = `${this.collabticApi}/threadpost/ChatFileUpload`;
            this.jobStatusApi = `${this.collabticForumApi}/getawsvideojobstatus`;
        } else {
            this.jobStatusApi = `${this.collabticForumApi}/getawsvideojobstatusV2`;
            this.threadPostApi = `${this.collabticApi}/threadpost/ChatFileUploadV2`;
        }

       /*if (this.platformInfo == "1") {
            this.jobStatusApi = `${this.collabticForumApi}/getawsvideojobstatusV2`;
            this.threadPostApi = `${this.collabticApi}/threadpost/ChatFileUploadV2`;
        }
         else if (this.platformInfo == "2") {
            this.threadPostApi = `${this.collabticApi}/threadpost/ChatFileUpload`;
            let domainId = localStorage.getItem('domainId');
            if (domainId == Constant.TVSdomainId) {
                this.jobStatusApi =  `${this.mahleV2Api}/managecontent/medisconvertjobstatus`;
            }
            else{
                this.jobStatusApi = `${this.collabticForumApi}/getawsvideojobstatus`;
            }
        } else {
           this.threadPostApi = `${this.collabticApi}/threadpost/ChatFileUpload`;
           this.jobStatusApi = `${this.collabticForumApi}/getawsvideojobstatus`;
        }*/
    }

    // Base Collabtic Forum API URL
    apiCollabticBaseUrl() {
        return `${this.collabticApi}`;
    }

    // Base Collabtic V3 API URL
    apiCollabticV3BaseUrl() {
        return `${this.collabticV3Api}`;
    }

    apiSolrSearchList() {
        // return 'http://devsolrsearch-env.eba-rcqceawd.us-west-2.elasticbeanstalk.com/nlp/api/v1/search';
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/search?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/search?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/search?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/search?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/search?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/search?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/search?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/search';
        }

    }

    apiSolrPDFSearchList() {
        let platformId = localStorage.getItem('platformId');
        if (platformId != '2') {
            let domainId = localStorage.getItem('domainId');
            if (domainId == Constant.CollabticBoydDomain) {
                return Constant.SolrAPIUrl + '/files?client=boyd';
            } else if (domainId == Constant.CollabticKeepsDataDomain) {
                return Constant.SolrAPIUrl + '/files?client=keeps';
            } else if (domainId == Constant.MSSdomainId) {
                return Constant.SolrAPIUrl + '/files?client=mss';
            } else if (domainId == Constant.tvsIBdomainId) {
                return Constant.SolrAPIUrl + '/files?client=tvsib';
            } else if (domainId == Constant.KIAdomainId) {
                return Constant.SolrAPIUrl + '/files?client=kia';
            } else if (this.platformIdInfo == PlatFormType.CbaForum) {
                return Constant.SolrAPIUrl + '/files?client=cbatac';
            } else if (Constant.acxDomain == '1') {
                return Constant.SolrAPIUrl + '/files?client=acx';
            } else {
                return Constant.SolrAPIUrl + '/files';
            }
        }
    }

    apiSolrThreadDetail() {
        // return 'http://devsolrsearch-env.eba-rcqceawd.us-west-2.elasticbeanstalk.com/nlp/api/v1/search';
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/detail?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/detail?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/detail?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/detail?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/detail?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/detail?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/detail?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/detail';
        }

    }

    apiSolrThreadDetailFixList() {
        // return 'http://devsolrsearch-env.eba-rcqceawd.us-west-2.elasticbeanstalk.com/nlp/api/v1/search';
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/detail/new?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/detail/new?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/detail/new?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/detail/new?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/detail/new?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/detail/new?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/detail/new?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/detail/new';
        }

    }

    apiSolrDataList() {
        // return 'http://devsolrsearch-env.eba-rcqceawd.us-west-2.elasticbeanstalk.com/nlp/api/v1/search';
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/list?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/list?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/list?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/list?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/list?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/list?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/list?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/list';
        }

    }

    apiSolrFilterList() {
        let SolrAPIUrl = Constant.SolrAPIUrl;
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return `${SolrAPIUrl}/filters?client=boyd`;
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/filters?client=keeps';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return `${SolrAPIUrl}/filters?client=cbatac`;
        } else if (domainId == Constant.MSSdomainId) {
            return `${SolrAPIUrl}/filters?client=mss`;
        } else if (domainId == Constant.tvsIBdomainId) {
            return `${SolrAPIUrl}/filters?client=tvsib`;
        } else if (domainId == Constant.KIAdomainId) {
            return `${SolrAPIUrl}/filters?client=kia`;
        } else if (Constant.acxDomain == '1') {
            return `${SolrAPIUrl}/filters?client=acx`;
        } else {
            return `${SolrAPIUrl}/filters`;
        }
    }

    apiSolrReportSearchList() {
        let SolrAPIUrl = Constant.SolrAPIUrl;
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return `${SolrAPIUrl}/reports/search?client=boyd`;
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return `${SolrAPIUrl}/reports/search?client=keeps`;
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return `${SolrAPIUrl}/reports/search??client=cbatac`;
        } else if (Constant.acxDomain == '1') {
            return `${SolrAPIUrl}/reports/search??client=acx`;
        } else {
            return `${SolrAPIUrl}/reports/search`;
        }
    }

    apiSolrManageReport() {
        let SolrAPIUrl = Constant.SolrAPIUrl;
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return `${SolrAPIUrl}/admin/reports/update?client=boyd`;
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return `${SolrAPIUrl}/admin/reports/update?client=keeps`;
        } else if (Constant.acxDomain == '1') {
            return `${SolrAPIUrl}/admin/reports/update?client=acx`;
        } else {
            return `${SolrAPIUrl}/admin/reports/update`;
        }
    }

    apiSolrBulkIndex() {
        let SolrAPIUrl = `${Constant.SolrAPIUrl}/admin/index/live/bulk`;
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return `${SolrAPIUrl}?client=boyd`;
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return `${SolrAPIUrl}?client=keeps`;
        } else {
            return `${SolrAPIUrl}`;
        }
    }

    apiSolrClusterList() {
        return Constant.SolrAPIUrl + '/search/clusters';
    }

    apiSolrClusterListNew() {
        return Constant.SolrAPIUrl + '/search/clusters/v1?client=keeps';
    }


    apiSolrSuggList() {
        let domainId = localStorage.getItem('domainId');
        // return 'http://devsolrsearch-env.eba-rcqceawd.us-west-2.elasticbeanstalk.com/nlp/api/v1/search';

        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/suggest/search?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/suggest/search?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/suggest/search?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/suggest/search?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/suggest/search?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/suggest/search?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/suggest/search?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/suggest/search';
        }
    }

    apiSolrSearchHistory() {
        let domainId = localStorage.getItem('domainId');
        // return 'http://devsolrsearch-env.eba-rcqceawd.us-west-2.elasticbeanstalk.com/nlp/api/v1/search';

        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/search/history?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/search/history?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/search/history?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/search/history?client=tvsib';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/search/history?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/search/history?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/search/history?client=collabtic';
        }
    }

  apiSolrSearchHistoryNew() {
    return Constant.SolrAPIUrl+'/search/history';
  }
    apiSolrLLMSummary() {
        //return Constant.SolrAPIUrl+'/search/summary?client=keeps';
        // return 'https://staging-beanstalk.collabtic.com/nlp/api/v2/search/summary?client=keeps';

        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/search/summary?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/search/summary?client=keeps';
        } else {
            return Constant.SolrAPIUrl + '/search/summary/suggest';
        }
    }

      apiSolrAISummary()
  {

    let domainId=localStorage.getItem('domainId');
    if(domainId==Constant.CollabticBoydDomain)
    {
      return Constant.SolrAPIUrl+'/search/summary?client=boyd';
    }
    else if(domainId==Constant.CollabticKeepsDataDomain)
    {
      return Constant.SolrAPIUrl+'/search/summary?client=keeps';
    }
    else if(domainId==Constant.MSSdomainId)
    {
      return Constant.SolrAPIUrl+'/search/summary?client=mss';
    }
    else if(domainId==Constant.tvsIBdomainId)
    {
      return Constant.SolrAPIUrl+'/search/summary?client=tvsib';
    }
    else if(domainId==Constant.KIAdomainId)
    {
      return Constant.SolrAPIUrl+'/search/summary?client=kia';
    }
    else if(this.platformIdInfo==PlatFormType.CbaForum)
    {
      return Constant.SolrAPIUrl+'/search/summary?client=cbatac';
    }
    else if(Constant.acxDomain=='1')
    {
      return Constant.SolrAPIUrl+'/search/summary?client=acx';
    }
    else
    {
      return Constant.SolrAPIUrl+'/search/summary';
    }

    //return Constant.SolrAPIUrl+'/search/summary?client=cbatac';
  }

    apiSolrReportSuggList() {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/suggest?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/suggest?client=keeps';
        } else {
            return Constant.SolrAPIUrl + '/reports/suggest';
        }
    }

    apiSolrFixSuggList() {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/typeahead?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/typeahead?client=keeps';
        } else {
            return Constant.SolrAPIUrl + '/reports/typeahead';
        }
    }

    // document List...
    apiSolrDocumentFileList() {

        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/list?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/list?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/list?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/list?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/list?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/list?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/list?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/list';
        }
        /*if(this.platformIdInfo==PlatFormType.CbaForum)
    {
      return Constant.SolrAPIUrl+'/list?client=cbatac';
    }
    else{
      return Constant.SolrAPIUrl+'/list';
    }*/
    }

    apiSolrDocumentSearchList() {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/search?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/search?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/search?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/search?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/search?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/search?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/search?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/search';
        }
        /*if(this.platformIdInfo==PlatFormType.CbaForum)
    {
      return Constant.SolrAPIUrl+'/search?client=cbatac';
    }
    else{
      return Constant.SolrAPIUrl+'/search';
    }*/
    }

    // document List...
    apiSolrDocumentFoldersList() {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/folders?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/folders?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/folders?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/folders?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/folders?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/folders?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/folders?client=cbatac';
        } else {
            return Constant.SolrAPIUrl + '/folders';
        }
        /*
      if(this.platformIdInfo==PlatFormType.CbaForum)
      {
        return Constant.SolrAPIUrl+'/folders?client=cbatac';
      }
      else{
        return Constant.SolrAPIUrl+'/folders';
      }
    */
    }


    // RO solr List...
    apiSolaPresetList(type) {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/' + type + '?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/' + type + '?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/' + type + '?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/' + type + '?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/' + type;
        }
    }

    // RO solr List...
    apiSolaList(type) {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/' + type + '?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/' + type + '?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/' + type + '?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/' + type + '?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/' + type;
        }
    }


    // RO solr List...
    apiSimilarSolrList(type) {
        let domainId = localStorage.getItem('domainId');
        let solrApiUrl = `${Constant.SolrAPIUrl}/similar/docs`;
        let clientPath = '?client=';
        let clientType = '';
        if (domainId == Constant.CollabticBoydDomain) {
            clientType = 'boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            clientType = 'keeps';
        } else if (domainId == Constant.MSSdomainId) {
            clientType = 'mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            clientType = 'tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            clientType = 'kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            clientType = 'cbatac';
        } else if (Constant.acxDomain == '1') {
            clientType = 'acx';
        } else {
            clientPath = '';
            clientType = '';
        }
        return `${solrApiUrl}${clientPath}${clientType}`;
    }

    // RO solr List...
    apiSimilarSIBSolrList(type) {
        let domainId = localStorage.getItem('domainId');
        let solrApiUrl = `${Constant.SolrAPIUrl}/sib/recommendations`;
        let clientPath = '?client=';
        let clientType = '';
        if (domainId == Constant.CollabticBoydDomain) {
            clientType = 'boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            clientType = 'keeps';
        } else if (domainId == Constant.MSSdomainId) {
            clientType = 'mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            clientType = 'tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            clientType = 'kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            clientType = 'cbatac';
        } else if (Constant.acxDomain == '1') {
            clientType = 'acx';
        } else {
            clientPath = '';
            clientType = '';
        }
        return `${solrApiUrl}${clientPath}${clientType}`;
    }

    // RO solr List...
    apiROSolrList(type) {
        let domainId = localStorage.getItem('domainId');
        let solrApiUrl = `${Constant.SolrAPIUrl}/${type}`;
        let clientPath = '?client=';
        let clientType = '';
        if (domainId == Constant.CollabticBoydDomain) {
            clientType = 'boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            clientType = 'keeps';
        } else if (domainId == Constant.MSSdomainId) {
            clientType = 'mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            clientType = 'tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            clientType = 'kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            clientType = 'cbatac';
        } else if (Constant.acxDomain == '1') {
            clientType = 'acx';
        } else {
            clientPath = '';
            clientType = '';
        }
        return `${solrApiUrl}${clientPath}${clientType}`;
    }

    apiRODetailSolrList() {
        let domainId = localStorage.getItem('domainId');
        let solrApiUrl = `${Constant.SolrAPIUrl}/detail/all`;
        let clientPath = '?client=';
        let clientType = '';
        if (domainId == Constant.CollabticBoydDomain) {
            clientType = 'boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            clientType = 'keeps';
        } else if (domainId == Constant.MSSdomainId) {
            clientType = 'mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            clientType = 'tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            clientType = 'kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            clientType = 'cbatac';
        } else if (Constant.acxDomain == '1') {
            clientType = 'acx';
        } else {
            clientPath = '';
            clientType = '';
        }
        return `${solrApiUrl}${clientPath}${clientType}`;
    }

    // Dispatch solr List...
    apiDispatchSolrList(type) {
        let domainId = localStorage.getItem('domainId');
        let solrApiUrl = `${Constant.SolrAPIUrl}/${type}`;
        let clientPath = '?client=';
        let clientType = '';
        if (domainId == Constant.CollabticBoydDomain) {
            clientType = 'boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            clientType = 'keeps';
        } else if (domainId == Constant.MSSdomainId) {
            clientType = 'mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            clientType = 'tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            clientType = 'kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            clientType = 'cbatac';
        } else if (Constant.acxDomain == '1') {
            clientType = 'acx';
        } else {
            clientPath = '';
            clientType = '';
        }
        return `${solrApiUrl}${clientPath}${clientType}`;
    }

    // RO solr Export List...
    apiSolarTVSExportList(type) {
        return Constant.fastAPIUrl + '/' + type;
    }

    // RO solr Export List...
      apiSolarThreadExportList(type)
      {
        let domainId=localStorage.getItem('domainId');
        if(domainId==Constant.CollabticBoydDomain)
        {
        return Constant.SolrAPIUrl+'/'+type+'/export&client=boyd';
        }
        else if(domainId==Constant.CollabticKeepsDataDomain)
        {
        return Constant.SolrAPIUrl+'/'+type+'/export&client=keeps';
        }
        else if(domainId==Constant.MSSdomainId)
        {
        return Constant.SolrAPIUrl+'/'+type+'/export&client=mss';
        }
        else if(domainId==Constant.tvsIBdomainId)
          {
          return Constant.SolrAPIUrl+'/'+type+'/export&client=tvsib';
          }
        else if(domainId==Constant.KIAdomainId)
        {
        return Constant.SolrAPIUrl+'/'+type+'/export&client=kia';
        }
        else if(this.platformIdInfo==PlatFormType.CbaForum)
        {
        return Constant.SolrAPIUrl+'/'+type+'/export&client=cbatac';
        }
        else if(Constant.acxDomain=='1')
          {
            return Constant.SolrAPIUrl+'/'+type+'/export&client=acx';
          }
        else
        {
        return Constant.SolrAPIUrl+'/'+type+'/export';
        }
      }


    // RO solr Export List...
    apiSolarThreadExportListNew(type)
    {
      let domainId=localStorage.getItem('domainId');
      if(domainId==Constant.CollabticBoydDomain)
      {
      return Constant.SolrAPIUrl+'/'+type+'/export/publish&client=boyd';
      }
      else if(domainId==Constant.CollabticKeepsDataDomain)
      {
      return Constant.SolrAPIUrl+'/'+type+'/export/publish&client=keeps';
      }
      else if(domainId==Constant.MSSdomainId)
      {
      return Constant.SolrAPIUrl+'/'+type+'/export/publish&client=mss';
      }
      else if(domainId==Constant.tvsIBdomainId)
        {
        return Constant.SolrAPIUrl+'/'+type+'/export/publish&client=tvsib';
        }
      else if(domainId==Constant.KIAdomainId)
      {
      return Constant.SolrAPIUrl+'/'+type+'/export/publish&client=kia';
      }
      else if(this.platformIdInfo==PlatFormType.CbaForum)
      {
      return Constant.SolrAPIUrl+'/'+type+'/export/publish&client=cbatac';
      }
      else if(Constant.acxDomain=='1')
        {
          return Constant.SolrAPIUrl+'/'+type+'/export/publish&client=acx';
        }
      else
      {
      return Constant.SolrAPIUrl+'/'+type+'/export/publish';
      }
    }

      // RO solr Export List...
    apiSolarSOExportList(type) {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/' + type + '?export=true&client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/' + type + '?export=true&client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?export=true&client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?export=true&client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?export=true&client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/' + type + '?export=true&client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/' + type + '?export=true&client=acx';
        } else {
            return Constant.SolrAPIUrl + '/' + type + 'export=true';
        }
    }

    // RO solr List...
    apiSolarSOList(type) {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/' + type + '?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/' + type + '?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/' + type + '?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/' + type + '?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/' + type + '?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/' + type;
        }
    }

    // RO solr List...
    apiSolarSIBList(type) {

        return Constant.SolrAPIUrl + '/' + type;

    }


    // ka category List...
    apiSolrKACatFoldersList() {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/folders/ka?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/folders/ka?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/folders/ka?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/folders/ka?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/folders/ka?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/folders/ka?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/folders/ka?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/folders/ka';
        }
    }


    // ka category List...
    apiSolrPartsCatFoldersList() {
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            return Constant.SolrAPIUrl + '/folders/parts?client=boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            return Constant.SolrAPIUrl + '/folders/parts?client=keeps';
        } else if (domainId == Constant.MSSdomainId) {
            return Constant.SolrAPIUrl + '/folders/parts?client=mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            return Constant.SolrAPIUrl + '/folders/parts?client=tvsib';
        } else if (domainId == Constant.KIAdomainId) {
            return Constant.SolrAPIUrl + '/folders/parts?client=kia';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            return Constant.SolrAPIUrl + '/folders/parts?client=cbatac';
        } else if (Constant.acxDomain == '1') {
            return Constant.SolrAPIUrl + '/folders/parts?client=acx';
        } else {
            return Constant.SolrAPIUrl + '/folders/parts';
        }
    }

    // Api Solr ADAS List
    apiSolrAdasList(type) {
        let apiPath = (type == 'folders') ? `${type}/adas` : type;
        let apiUrl = `${Constant.SolrAPIUrl}/${apiPath}`;
        let clientFlag = true;
        let clientType = '';
        let domainId = localStorage.getItem('domainId');
        if (domainId == Constant.CollabticBoydDomain) {
            clientType = 'boyd';
        } else if (domainId == Constant.CollabticKeepsDataDomain) {
            clientType = 'keeps';
        } else if (domainId == Constant.MSSdomainId) {
            clientType = 'mss';
        } else if (domainId == Constant.tvsIBdomainId) {
            clientType = 'tvsib';
        } else if (this.platformIdInfo == PlatFormType.CbaForum) {
            clientType = 'cbatac';
        } else {
            clientFlag = false;
        }
        if (clientFlag) {
            apiUrl = `${apiUrl}?client=${clientType}`;
        }
        return apiUrl;
    }

    // Base Dashboard API URL
    apiDashboardBaseUrl() {
        return `${this.collabticDashApi}`;
    }

    // Get Lang Api URL
    getLangApiUrl() {
        return `${this.langApi}`;
    }

    // Get Lang Api URL
    getGooglelangApiUrl(apiData) {

        //alert(apiData.key);

        return 'https://translation.googleapis.com/language/translate/v2?key=' + apiData.key + '&q=' + apiData.q + '&target=' + apiData.target + '&source=' + apiData.source + '';
    }

    DetectGoogleContentlang(apiData) {

        //alert(apiData.key);

        return 'https://translation.googleapis.com/language/translate/v2/detect?key=' + apiData.key + '&q=' + apiData.q + '';
    }


    // Get Dashboard Filter Widget Lists
    apiGetDashboardFilterWidgets() {
        return `${this.collabticDashApi}/dashboardFilterWidgets`;
    }

    apiGetWebAppVersion() {
        return `${this.collabticForumApi}/WebAppVersion`;
    }

    // Dashboard
    apiDashboard() {
        return `${this.collabticDashApi}/userDashboardreportv2updated`;
    }

    // Chart Details
    apiChartDetail() {
        return `${this.collabticDashApi}/ChartDetails`;
    }

    // Geographical Lists
    apiGeoList() {
        return `${this.collabticDashApi}/geographicalwidgets`;
    }

    // Export Dealer Activity
    apiExportDealerActivity() {
        return `${this.collabticDashApi}/useractivityfilterexport`;
    }

    // Get User Profile
    apiUserProfile() {
        return `${this.collabticApi}/user/getuserdetails`;
    }

    // Get User Profile
    getUserSubscribedetails() {
        return `${this.collabticLocalhost}/accounts/getusersubscribedetails`;
    }

    // New Probing Question
    apiNewProbingQuest() {
        return `${this.collabticProbingApi}/createProbingQuestions`;
    }

    // Get Probing Lists
    apiGetProbingLists() {
        return `${this.collabticProbingApi}/GetProbingquestionsList`;
    }

    // Get Probing Lists
    apiGetUserAvailability() {
        return `${this.collabticForumApi}/GetUserAvailability`;
    }

    // Delete Probing Question
    apiDeleteProbingQuest() {
        return `${this.collabticProbingApi}/deleteProbingQuestions`;
    }

    // Get Workstream Lists
    apiGetWorkstreamLists() {
        return `${this.collabticForumApi}/GetworkstreamsList`;
    }

    apiGetMsoNameLists() {
        return `${this.collabticV3Api}/shop/mso-name-list`;
    }

    apiUpdateServiceShopDetails() {
        return `${this.collabticV3Api}/shop/update-service-shop-details`;
    }

    apiGetMsoLocations() {
        return `${this.collabticV3Api}/shop/mso-locations`;
    }

    apiManageMsoLocations() {
        return `${this.collabticV3Api}/shop/manage-mso-locations`;
    }

    apiListMsoLocations() {
        return `${this.collabticV3Api}/shop/mso-locations-list`;
    }

    apiUpdateMsoDetails() {
        return `${this.collabticV3Api}/shop/update-mso-details`;
    }

    apiRemoveMsoLocations() {
        return `${this.collabticV3Api}/shop/remove-mso-location`;
    }

    apiMsoList() {
        return `${this.collabticV3Api}/shop/mso-list`;
    }

    apiCustomerTags() {
        return `${this.collabticV3Api}/shop/tags`;
    }

    apiManageMsoNameLists() {
        return `${this.collabticV3Api}/shop/manage-mso-name`;
    }

    // Get Subscription Workstream Lists
    apiGetSubscriptionWorkstreamLists() {
        return `${this.collabticV3Api}/market-place/getusersubscriptionworkstreams`;
    }

    apiGetWorkstreamListsAPI() {
        return `${this.collabticForumApi}/GetworkstreamsAPI`;
    }

    apiGetworkstreamswithCount() {
        let platformId = localStorage.getItem("platformId");
        if (platformId == PlatFormType.CbaForum) {
            return `${this.collabticForumApi}/GetworkstreamsV3`;
        } else {
            return `${this.collabticForumApi}/GetworkstreamsAPI`;
        }
    }

    apiGetUserPieChartsData() {
        let platformId = localStorage.getItem("platformId");
        return `${this.collabticForumApi}/Userpiecharts`;
    }

    // Landing page widgets
    apiGetLandingpageOptions() {
        return `${this.collabticLandingApi}/GetLandingPagewidgets`;
    }

    // Landing page widgets
    apiGetLandingpageOptionsV3() {
        return `${this.collabticLandingApi}/GetLandingPagewidgetsV3`;
    }

    apiGetRecentViews() {
        return `${this.collabticLandingApi}/GetRecentViews`;
    }

    apiGetEquipmentList() {
        return `${this.collabticForumApi}/pingreportlist`;
    }

    apiTechSupportWidgets() {
        return `${this.collabticLandingApi}/TechSupportWidgets`;
    }

    apiManualsAndAnnouncementList() {
        return `${this.resourceApi}/ManualsAndAnnouncementList`;
    }

    apigetescalatethreadsAPI() {
        return `${this.collabticForumApi}/getescalatethreadsAPI`;
    }

    apiGetactionuseractivity() {
        return `${this.collabticDashApi}/Getactionuseractivityv2`;
    }

    apigetusersearchHistory() {
        return `${this.searchApi}/GetusersearchHistory`;
    }

    apithreadwithWorkstreams() {
        return `${this.searchApi}/threadwithWorkstreams`;
    }

    apiclearsearchhistory() {
        return `${this.searchApi}/clearsearchhistory`;
    }

    apiUpdateSearchKeyword() {
        return `${this.searchApi}/UpdateSearchKeyword`;
    }


    apiEnhancedSearchAPI() {
        return `${this.searchApi}/EnhancedsearchAPI`;
    }

    apiGetAlldomainUsers() {
        return `${this.collabticForumApi}/GetAlldomainUsersAPI`;
    }

    apiGetServiceJobTitleList() {
        return `${this.collabticV3Api}/services/job-title-list`;
    }

    apiGetServiceToolList() {
        return `${this.collabticV3Api}/support-tickets/tool-list`;
    }

    apiManageServiceJobTitleList() {
        return `${this.collabticV3Api}/services/manage-job-title`;
    }

    apiTechSupportCommonAPIs() {
        return `${this.collabticForumApi}/TechSupportCommonAPIs`;
    }

    readandDeleteNotification() {
        return `${this.collabticApi}/forumnewversion/ReadandDeleteNotificationAPI`;
    }

    apiThreadCharts() {
        return `${this.collabticDashApi}/threadsCharts`;
    }

    // Get Product Type Lists
    apiGetProdTypeLists() {
        return `${this.collabticForumApi}/getProdTypeList`;
    }

    //for getting knowledge articles category
    apiAllKnowledgeArticleCategory() {
        return `${this.collabticApi}/softwaredl/GetKnowledgeArticlesByCategory`;
    }

    //for getting knowledge articles category
    apiAllPartCategory() {
        return `${this.collabticApi}/parts/GetpartsByCategory`;
    }

    //for getting knowledge articles
    getAllKnowledgeArticle() {
        return `${this.collabticApi}/softwaredl/getKnowledgeArticlesList`;
    }

    // for manage knowledge article new and edit
    apiManageKnowledgeType() {
        return `${this.collabticApi}/softwaredl/SaveArticleV2`;
    }

    //for deleting knowledge articles
    apiDeleteKnowledgeArticle() {
        return `${this.collabticApi}/softwaredl/deleteArticles`;
    }

    getKnowledgeArticlesDetails() {
        return `${this.collabticApi}/softwaredl/getKnowledgeArticlesDetails`;
    }

    // Get Workstream Detail
    apiGetWorkstreamDetail() {
        return `${this.collabticForumApi}/LoadWorkstreamDetail`;
    }

    // Get Workstream Detail
    apiGetCategoryDetail() {
        return `${this.collabticForumApi}/GetThreadCategory`;
    }

    // Get Workstream Users
    apiGetWorkstreamUsers() {
        return `${this.collabticForumApi}/LoadWorkstreamDetailUsers`;
    }

    // Check Workstream Name Exists
    apiCheckWorkstreamName() {
        return `${this.collabticForumApi}/CheckWorkstreamTitle`;
    }

    // New Workstream
    apiNewWorkstream() {
        return `${this.collabticForumApi}/createWorkstreams`;
    }

    // Save Workstream
    apiSaveWorkstream() {
        return `${this.collabticForumApi}/SaveWorkstreammembers`;
    }

    // Get Vehicle Model Lists
    apiGetVehicleModelLists() {
        return `${this.collabticVehicleApi}/getmodelAPI`;
    }

    // get workflow
    apiWorkFlowContentTypes() {
        return `${this.collabticApi}/gts/workFlowContentTypes`;
    }

    // Get GTS Lists
    apiGetGTSLists() {
        return `${this.collabticApi}/GTS/GetGTSProcedureListingWeb`;
    }

    // Update GTS Status
    apiUpdateGTSStatus() {
        return `${this.collabticApi}/GTS/GTSUpdateExitStatus`;
    }

    //remove attachment
    apiDeleteAttachmentInfo() {
        return `${this.collabticApi}/Gts/DeleteAttachmentInfo`;
    }

    // Get GTS Lists
    apiGetGTSSessions() {
        return `${this.collabticApi}/GTS/GetGTSSessions`;
    }

    // Get Recent Frame Selection
    apiGetGTSRecentFrameSelection() {
        return `${this.collabticApi}/GTS/GetRecentFrameNoSelection`;
    }

    apiUpdateGTSCheckAction() {
        return `${this.collabticApi}/Gts/GTSUpdateCheckActions`;
    }

    apiGTSUpdateUserInputCheckActions() {
        return `${this.collabticApi}/Gts/GTSUpdateUserInputCheckActions`;
    }

    // Get Vehicle Model Lists
    apiGetVehicleModelListsGTS() {
        return `${this.collabticApi}/vehicle/getmodelAPI`;
    }

    // Get GTS BaseInfo
    apiGetGtsBaseInfo() {
        return `${this.collabticApi}/GTS/GetGTSAttributesInfo`;
    }

    // Get Product Category & Types
    apiGetProdCatg() {
        return `${this.collabticApi}/GTS/GetGTSProdCategoryandType`;
    }

    // Get Sessions List
    apiGetSessionsList() {
        return `${this.collabticApi}/GTS/GetGTSSessions`;
    }

    // Get Sessions List excel report
    createGtsSessionListReport() {
        return `${this.collabticV3Api}/market-place/creategtssessionlistreport`;
    }

    latestGtsSessionReport() {
        return `${this.collabticV3Api}/market-place/latestgtssessionreport`;
    }

    // Get Sessions List
    apiGetSessionSummary() {
        return `${this.collabticApi}/GTS/GetGTSSessionSummary`;
    }

    apiDisplayOrderSessionSummaryImg() {
        return `${this.collabticApi}/forum/Updatemediadisplayorder`;
    }

    apiUploadSessionSummeryImg() {
        return `${this.uploadApi}`;
    }

    // Get Module Manufacture
    apiGetModMft() {
        return `${this.collabticApi}/GTS/GetGTSProdCategoryandType`;
    }

    // Get DTC Info
    apiGetDtcInfo() {
        return `${this.collabticApi}/GTS/GetDTCInfo`;
    }

    // GET DTC Attributes
    apiGetDtcAttributes() {
        return `${this.collabticApi}/GTS/GetDTCAttributesInfo`;
    }

    // GTS Procedure Creation and Update
    apiManageGts() {
        return `${this.collabticApi}/GTS/SaveGTSProcedure`;
    }

    // Delete DTS Procedure
    apiDeleteGts() {
        return `${this.collabticApi}/GTS/DeleteGTSProcedure`;
    }

    // Delete DTS Procedure
    apiRestoreGts() {
        return `${this.collabticApi}/GTS/RestoreGTSProcedure`;
    }

    // Add or Save Manufacturer
    apiManageMFG() {
        return `${this.collabticApi}/GTS/SaveprodMfg`;
    }

    // Add or Save System
    apiManageSystem() {
        return `${this.collabticApi}/GTS/SaveprodSystem`;
    }

    // Add or Save DTC Code
    apiManageDTC() {
        return `${this.collabticApi}/GTS/SaveprodDtc`;
    }

    // Check DTC Code Exists
    apiCheckDTC() {
        return `${this.collabticApi}/GTS/CheckDTCAvailablity`;
    }

    // Get GTS Procedure Attachment
    apiGetGTSProcedureAttachment() {
        return `${this.collabticApi}/GTS/GetGTSProcedureAttachment`;
    }

    // Add or Save Tag
    apiManageTagGTS() {
        return `${this.collabticApi}/GTS/SaveprodTags`;
    }

    // Add or Save Product Category
    apiManageProblemCatg() {
        return `${this.collabticApi}/GTS/SaveprodCategory`;
    }

    // Add or Save ECU Type
    apiManageECUType() {
        return `${this.collabticApi}/GTS/SaveprodECUType`;
    }

    // Get Product Matrix Lists
    apiGetProductLists() {
        return `${this.productInfoApi}/getProductMatrix`;
    }

    // Check Model Exists
    apiCheckModelExists() {
        return `${this.productInfoApi}/CheckMakeModelExist`;
    }

    // Check Model Exists
    apicheckModelAutoComplete() {
        return `${this.productInfoApi}/getproductModelListautoComplete`;
    }

    // Add or Save Product Matrix
    apiManageProductMatrix() {
        return `${this.productInfoApi}/SaveproductMatrix`;
    }

    apiUpdateProductMatrixByModel() {
        return `${this.productInfoApi}/updateProductMatrixByModel`;
    }

    apiSaveproductMatrixBYModel() {
        return `${this.productInfoApi}/SaveproductMatrixBYModel`;
    }

    apigetPMColumns() {
        return `${this.productInfoApi}/getPMColumns`;
    }

    apigetEscalationColumns() {
        return `${this.escalationV2Api}/getPMColumns`;
    }

    apiGetEmployeeEscalation() {
        return `${this.escalationV2Api}/GetEscalationDataMetrics`;
    }

    apiupdateEscalationData() {
        return `${this.escalationV2Api}/updateEscalationData`;
    }

    apiupdateEscalationDataV2() {
        return `${this.escalationV2Api}/updateEscalationDataV2`;
    }

    apiGetAllEscalationUsers() {
        return `${this.escalationV2Api}/getallEscalationUsers`;
    }

    apigetEscalationLookupTableData() {
        return `${this.collabticForumApi}/CommonAttributeValues`;
    }

    apigetEscalationConfigData() {
        return `${this.escalationV2Api}/EscalationConfig`;
    }

    apigetAlertEscalationConfigData() {
        return `${this.escalationV2Api}/EscalationreminderAlertConfig`;
    }

    //Escalations By Levels
    apiGetEscalationsThreadsView() {
        return `${this.collabticLandingApi}/Getescalationthreadsview`;
    }

    //Escalations By Levels
    apiGetEscalationsByLevels() {
        return `${this.collabticForumApi}/GetEscalationsByLevels`;
    }

    apiGetGTSProcedures() {
        return `${this.collabticApi}/Gts/GetGtsProcedures`
    }

    apiGetUploadAttachments() {
        return `${this.collabticApi}/GtsAttachment/uploadAttachments`
    }

    apiGTSFrameDecode() {
        return `${this.collabticApi}/Gts/FrameDecode`
    }

    apicheckHeaderExists() {
        return `${this.productInfoApi}/checkHeaderExists`;
    }

    apiupdatePlaceholderByHeader() {
        return `${this.productInfoApi}/updatePlaceholderByHeader`;
    }

    apiAddNewColumn() {
        return `${this.productInfoApi}/AddNewColumn`;
    }

    apigetLookupTableData() {
        return `${this.productInfoApi}/getLookupTableData`;
    }

    apiManageLookUpdata() {
        return `${this.productInfoApi}/SaveLoopUpdata`;
    }

    apigetPMColumnsValues() {
        return `${this.productInfoApi}/getPMColumnsValues`;
    }

    // Active or Deactive Product Matrix
    apiActionProductMatrix() {
        return `${this.productInfoApi}/UpdateModelmakeStatus`;
    }

    // Get Product Make Lists
    apiGetProductmakeList() {
        return `${this.productInfoApi}/getproductmakeList`;
    }

    // Get Product Type
    apiGetProductSubGroupList() {
        return `${this.productInfoApi}/GetProductTypeList`;
    }

    // Get Product Sub Group
    apiGetProductTypeList() {
        return `${this.productInfoApi}/productTypeListDoc`;
    }

    // Add or Save Make
    apiActionMake() {
        return `${this.productInfoApi}/Saveproductmake`;
    }

    // Show Category and Subcategory
    apigetproductCategandSubcat() {
        return `${this.productInfoApi}/getproductCategandSubcat`;
    }

    // Get Menu Lists
    apiGetMenuLists() {
        return `${this.collabticAccountsApi}/getHeaderandsideMenuAPIv2`;
    }

    // Get Dashboard Menu Lists
    apiGetDashMenuLists() {
        return `${this.collabticAccountsApi}/getHeaderandsideMenuAPI`;
    }

    // Delete Workstream
    apiDeleteWorkstream() {
        return `${this.collabticForumApi}/DeleteWorkstreamItems`;
    }

    apigetUserListDashboard() {
        if (this.platformInfo != "1") {
            return `${this.collabticDashApi}/getuserlistAPI`;
        } else {
            return `${this.collabticDashApi}/getuserlist`;
        }
    }

    apigetDomainListDashboard() {

        return `${this.collabticDashApi}/DomainsExport`;

    }

    apiUpdateUserDashstatus() {
        if (this.platformInfo != "1") {
            return `${this.collabticDashApi}/updateusersAPI`;
        } else {
            return `${this.collabticDashApi}/updateusers`;
        }
    }

    apiGetUserManagersList() {
        return `${this.collabticDashApi}/getmanagerlistV2`;
    }

    apiDeleteAccountUserInfo() {
        return `${this.collabticAccountsApi}/DeleteAccountUserInfo`;
    }

    apiDeleteMultipleAccountUserInfo() {
        return `${this.collabticAccountsApi}/DeleteAccountmiltipleUserInfo`;
    }

    apiUpdateUserpasswordbyAdmin() {
        return `${this.collabticAccountsApi}/adminChangepassword`;
    }

    apiupdateuserInfobyAdmin() {
        return `${this.collabticAccountsApi}/updateuserInfo`;
    }

    apiAddInviteUserbyAdmin() {
        return `${this.collabticAccountsApi}/bussinessInviteRegister`;
    }

    apiCheckemailstatus() {
        return `${this.collabticAccountsApi}/Checkemailstatus`;
    }

    apiLikePinKnowledgeArticleAction() {
        return `${this.knowledgeArticleApi}/AddLikePins`;
    }

    apiLikePinGtsAction() {

        return `${this.collabticApi}/GTS/AddLikePins`;
    }

    /*** Parts API Start ***/
    // Get Parts List
    apiGetPartsList() {
        return `${this.partsApi}/GetPartsListingweb`;
    }

    // Get Part Attributes
    apiGetPartBaseInfo() {
        return `${this.partsApi}/GePartsAttributesInfo`;
    }

    // Get Parts Detail
    apiGetPartsDetail() {
        return `${this.partsApi}/GetPartsDetailsweb`;
    }

    // Check part no duplicate
    apiCheckPartNoIsExist() {
        return `${this.partsApi}/CheckPartNoIsExist`;
    }

    // Manage Parts Create or Edit
    apiManageParts() {
        return `${this.partsApi}/SaveParts`;
    }

    // Get Model List By Make
    apiGetModels() {
        return `${this.productmakeApi}/GetModelformakeAPI`;
    }

    apiGetuserExportAll() {
        return `${this.collabticDashApi}/getuserlistexcelupdated`;
    }

    apiGetuserExportThread() {
        return `${this.collabticForumApi}/GetallThreadExportHeaders`;
    }

    apiGetallThreadExportData() {
        return `${this.collabticForumApi}/GetallThreadExportData`;
    }

    apiSendPaymentDetail() {
        return `${this.collabticLocalhost}/payment/add`;
    }

    apiCheckNewTrainingId() {
        return `${this.collabticLocalhost}/market-place/getnewtrainingid`;
    }

    apiSendManualPaymentDetail() {
        return `${this.collabticLocalhost}/payment/addmanual`;
    }

    apiSendPaymentDetailByCheck() {
        return `${this.collabticLocalhost}/payment/addbycheck`;
    }

    apiSendCartPaymentDetail() {
        return `${this.collabticLocalhost}/market-place/cartpaymentnew`;
        // return `${this.collabticLocalhost}/market-place/cartpayment`;
    }


    apiSendMessageToSlack() {
        return `${this.collabticLocalhost}/market-place/sendmessagetoslackchannel`;
        // return `${this.collabticLocalhost}/market-place/cartpayment`;
    }

    apiSendCartOrderDetail() {
        return `${this.collabticLocalhost}/market-place/cartorder`;
    }

    apiSendTwilioSms() {
        return `${this.collabticLocalhost}/market-place/sendsms`;
    }

    /*** Parts API End ***/

    // Get Tags List
    apiGetTagList() {
        return `${this.resourceApi}/gettagslists`;
    }

    // Add or Save Tag
    apiManageTag() {
        return `${this.partsApi}/SaveprodTags`;
    }

    // delete Tag
    deleteTag() {
        return `${this.resourceApi}/DeleteTagsInfo`;
    }

    // delete Tag
    deleteSNo() {
        return `${this.resourceApi}/DeleteSerialNoInfo`;
    }

    // Get Related Thread Lists
    apiGetRelatedThreads() {
        return `${this.collabticForumApi}/ReleatedThreadsWeb`;
    }

    // Get Error Codes List
    apiGetErrorCodes() {
        return `${this.collabticForumApi}/ErrorCodes`;
    }

    // Manage Error Code
    apiManageErrorCode() {
        return `${this.partsApi}/saveErrorCode`;
    }

    // Manage Part Type
    apiManagePartType() {
        return `${this.partsApi}/savePartType`;
    }

    // Manage Part System
    apiManagePartSystem() {
        return `${this.partsApi}/SavepartSystem`;
    }

    // Manage Part Assembly
    apiManagePartAssembly() {
        return `${this.partsApi}/savepartAssembly`;
    }

    // Manage Part sold
    apiManagePartSold() {
        return `${this.partsApi}/Savepartsold`;
    }

    // Update Part Status
    apiUpdatePartStatus() {
        return `${this.partsApi}/UpdatePartStatus`;
    }

    // Get Filter Widgets
    apiGetFilterWidgets() {
        return `${this.collabticAccountsApi}/FilterWidgets`;
    }

    // Manage Filter Settings
    apiManageFilterSettings() {
        return `${this.collabticAccountsApi}/SaveFilterSettings`;
    }

    // Get Upload URL
    apiGetUploadURL() {
        return this.uploadApi;
    }

    // Get Recent Part View Lists
    apiRecentPartViews() {
        return `${this.partsApi}/GetPartRecentViews`;
    }

    // Like & Pin Actions
    apiLikePinAction() {
        return `${this.partsApi}/AddLikePins`;
    }

    // Delate Part
    apiDeletePart() {
        return `${this.partsApi}/DeletePartInfo`;
    }

    // Delate SIB
    apiDeleteSib() {
        return `${this.demoGtsMahale}/sib/DeleteSIBInfo`;
    }

    // Get Vimeo Video Thumb
    apiGetVimeoThumb(vid) {
        return `${this.vimeoApi}/${vid}.json`;
    }

    // Get Media Lists
    getFoldersandDocumentsApi() {
        return `${this.resourceApi}/GetfoldersandDocumentsv1`;
    }

    /* Media Manager API */

    // Get Media Lists
    apiGetMediaLists() {
        return `${this.mediaApi}/GetMediaList`;
    }

    // Update Media Content
    apiUpdateMediaContent() {
        return `${this.mediaApi}/UpdateMediaByContentType`;
    }

    // Check Media Name
    apiCheckMediaName() {
        return `${this.mediaApi}/CheckforDuplicatesMedia`;
    }

    // Get PDF Link By Media ID
    apiGetMediaPDFLink() {
        return `${this.collabticV3Api}/media/getmedialink`;
    }

    // Save Media
    apiSaveMedia() {
        return `${this.mediaApi}/saveMedia`;
    }

    // Get Media Upload URL
    apiGetMediaUploadURL() {
        //return `${this.mediaApi}/UpdateandUploadattachments`;
        if (this.platformInfo != "1") {
            return `${this.collabticApi}/threadpost/AttachmentUpload`;
        } else {
            return `${this.collabticApi}/threadpost/AttachmentUploadV2`;
        }
    }

    // Get Media Upload file URL
    apiCheckUploadMedia() {
        //return `${this.mediaApi}/UpdateandUploadattachments`;
        //return `${this.collabticApi}/threadpost/AttachmentUpload`;
        if (this.platformInfo != "1") {
            return `${this.collabticApi}/threadpost/AttachmentUpload`;
        } else {
            return `${this.collabticApi}/threadpost/AttachmentUploadV2`;
        }
    }

    // Delete Media Api
    apiDeleteMedia() {
        return `${this.mediaApi}/DeleteMediaInfo`;
    }

    // Get Site Logo
    apiGetSiteLogo() {
        return `${this.collabticForumApi}/getLinkInfo`;
    }

    // Get user notifications
    apiusernotifications() {
        return `${this.notificationApi}/DisplayNotificationmobile`;
    }

    //FCM save User Token for sending and receive push
    apiregisterdevicetoken() {
        return `${this.pushApi}/registerdevicetokenWeb`;
    }

    apiActiveDevicesOnPageWeb() {
        return `${this.pushApi}/ActiveDevicesOnPageWeb`;
    }

    // Reset user notifications
    apiresetusernotifications() {
        return `${this.notificationApi}/Notificationcountreset`;
    }

    // Read or Delete user notifications
    apiReadandDeleteNotification() {
        return `${this.notificationApi}/ReadandDeleteNotificationAPI`;
    }

    // Delete All user notifications
    apiDismissallnotifications() {
        return `${this.notificationApi}/dismissallnotificationsAPI`;
    }

    // Like & Pin Actions
    apiMediaLikePinAction() {
        return `${this.mediaApi}/AddLikePins`;
    }

    /* Escalations API */

    // Get Escalation API
    apiGetEscalationLists() {
        return `${this.collabticForumApi}/GetEscalationexcelData`;
    }

    apigetSystemActivity() {
        return `${this.collabticForumApi}/getSystemActivity`;
    }

    // Get Escalation PPFR API
    apiGetEscalationListsPPFR() {
        return `${this.collabticForumApi}/EscformListing`;
    }

    apiGetDashboardUpdate() {
        return `${this.collabticForumApi}/GetDashboardUpdate`;
    }

    apiGetWeeklyDashboard() {
        return `${this.collabticLocalhost}/forum/excelaereportweek`;
    }

    apiGetDashboardUpdateTechSupport() {
        return `${this.collabticForumApi}/GetDashboardUpdateTechSupport`;
    }

    apiGetTechSupportDailyTickets() {
        return `${this.collabticV3Api}/forum/techsupportdailyticket`;
    }

    apiDownloadTechSupportTickets() {
        return `${this.collabticV3Api}/forum/downloadtechsupporttickets`;
    }

    apiGetTechSupportTickets() {
        return `${this.collabticV3Api}/forum/techsupporttickets`;
    }

    apiGetChartUpdate() {
        return `${this.collabticDashApi}/GetDashboardUpdate`;
    }

    apiGetDashboardmetrics() {
        return `${this.collabticDashApi}/GetDashboardmetrics`;
    }

    // Save Escalation API
    apiSaveEscalation() {
        return `${this.collabticForumApi}/SaveEscalationMData`;
    }

    // Escalation Notification API
    apiEscalationNotify() {
        return `${this.collabticForumApi}/SendMEscalationNotifications`;
    }

    apigetWorksteamOrGroupChat() {
        return `${this.collabticForumApi}/Getworkstramschat`;
    }

    apigetWorksteamOrGroupChatV2() {
        return `${this.collabticForumApi}/GetworkstramschatAPI`;
    }

    apigetDomainUserList() {
        return `${this.collabticForumApi}/GetAlldomainUsersAPI`;
    }

    apigetTransactionUsersList() {
        return `${this.collabticLocalhost}/market-place/gettransactionuserslist`;
    }

    apigetcompanyusersbyname() {
        return `${this.collabticLocalhost}/market-place/getcompanyusersbyname`;
    }

    apigetsalesrepsList() {
        return `${this.collabticLocalhost}/market-place/getsalesreps`;
    }

    apiAddworkstreamChat() {
        let platformId = localStorage.getItem("platformId");
        if (platformId != "1") {
            return `${this.collabticForumApi}/addworkstreamchatAPI`;
        } else {
            return `${this.collabticForumApi}/addworkstreamchat`;
        }
    }

    apiAddPostNotification() {
        return `${this.notificationApi}/pushnotificationGroupmessage`;
    }

    apiGetChatUploadURL() {
        let platformId = localStorage.getItem("platformId");
        if (platformId != "1") {
            return `${this.threadPostApi2}ChatFileUploadAPI`;
        } else {
            return `${this.threadPostApi}/ChatFileUploadV2`;
            //return `${this.threadPostApi}/ChatFileUpload`;
        }
    }

    apiDeleteworkstreamChat() {
        let platformId = localStorage.getItem("platformId");
        if (platformId == "1") {
            return `${this.collabticForumApi}/Deleteworkstreamchat`;
        } else {
            return `${this.collabticForumApi}/DeleteworkstreamchatAPI`;
        }
    }

    apiGetUserMetrics() {
        return `${this.collabticForumApi}/getAllviews`;
    }

    apiGetTechInfoMetrics() {
        return `${this.resourceApi}/Gettechinfometrics`;
    }


    /*** Authentication ***/
    // validate domain name
    apivalidateSubDomain() {
        return `${this.collabticAccountsApi}/validatesubdomainapi`;
    }

    //validate email id / user name and password
    apiLogin() {
        let platformId = localStorage.getItem("platformId");
        if (platformId == PlatFormType.CbaForum) {
            return `${this.collabticAccountsApi}/loginApiV2`;
        } else {
            return `${this.collabticAccountsApi}/loginapi`; // Yii 1 Function
            // return `${this.collabticAccountsApiv2}/loginapi`; //Yii 2 Function
        }
    }

    apiLoginCbtFixsso() {
        let platformId = localStorage.getItem("platformId");

        return `${this.collabticAccountsApi}/logincbtfixes`;

    }

    apicheckAccountInfo() {
        return `${this.collabticAccountsApi}/checkAccountInfo`;
    }

    //validate email id / user name and password
    apiSignup() {
        return `${this.collabticAccountsApi}/checkValidUser`;
    }

    apiCustomerSignup() {
        return `${this.collabticAccountsApiv2}/checkvaliduser`;
    }


    //validate email id - password reset
    apiResetPassword() {
        return `${this.collabticAccountsApi}/ResetpasswordApp`;
    }

    //reset password
    apiChangePassword() {
        return `${this.collabticAccountsApi}/changepassword`;
    }

    apiNewBusinessSignup() {
        return `${this.collabticAccountsApi}/NewBusinessRegister`;
    }

    /*** Authentication ***/

    // Change password
    apiChangeUserPassword() {
        return `${this.collabticAccountsApi}/changepasswordApp`;
    }

    // Change force password
    apiChangeFPassword() {
        return `${this.collabticAccountsApi}/changetemppassword`;
    }

    // All Folders
    apiSaveDocumentFolder() {
        return `${this.resourceApi}/SaveDocumentFolder`;
    }

    // Save Folders (Add and Update and Delete)
    apiGetDocumentFolder() {
        return `${this.resourceApi}/getFoldersforDocument`;
    }

    // Save Folders (Add and Update and Delete)
    apiSaveCategoryFolder() {
        return `${this.knowledgeArticleApi}/SaveCategoryFolder`;
    }

    // Save Folders (Add and Update and Delete)
    apiSavePartCategoryFolder() {
        return `${this.partsApi}/SaveCategoryFolder`;
    }

    //get manager list
    apiGetManagerList() {
        return `${this.collabticAccountsApi}/getmanagerList`;
    }

    //update manager
    apiUpdateManagerList() {
        return `${this.collabticAccountsApi}/updateuersignupinfo`;
    }

    //landing page reports
    apiLandingreports() {
        return `${this.collabticAccountsApi}/getReportsAttr`;
    }

    //reset verification email
    apiResetVerificationEmail() {
        return `${this.collabticAccountsApi}/resendEmail`;
    }

    //reset verification email
    apiResetVerificationEmailV2() {
        return `${this.collabticAccountsApiv2}/resendEmail`;
    }

    //user checked verification email
    apiVerifiedEmail() {
        return `${this.collabticAccountsApi}/EmailVerificationStatus`;
    }

    // get language list
    apiGetLangUageList() {
        return `${this.resourceApi}/getLangUageList`;
    }


     apiGetactivethreadusers() {
        return `${this.collabticApi}/forum/getactivethreadusers`;
    }



    // set language list
    apiSaveUserLanguageOption() {
        return `${this.collabticAccountsApi}/SaveUserLanguageOption`;
    }

    //profile upload
    apifileUpload() {
        return `${this.collabticAccountsApi}/profilephoto`;
    }

    //video category image upload
    apiVideoCategoryImgfileUpload() {
        return `${this.collabticLocalhost}/accounts/profilephotonew`;
    }

    // Remove Logo
    apiRemoveLogo() {
        return `${this.collabticAccountsApi}/removeLogo`;
    }

    //user checked verification email
    apiGetPolicyContent() {
        return `${this.collabticAccountsApi}/TVSIBPrivacyPolicy`;
    }

    /*** Authentication ***/

    /*** Profile */

    apiGetUserProfile() {
        return `${this.collabticAccountsApi}/GetUserprofile`;
    }

    apiUpdateUserProfile() {
        return `${this.collabticAccountsApi}/UpdateprofileUserV2`;
    }

    apiUpdateStagename() {
        return `${this.collabticAccountsApi}/UpdateStagename`;
    }

    apiGetProfileMetrics() {
        return `${this.collabticForumApi}/ProfileMetrics`;
    }

    apiGetCertificationList() {
        return `${this.collabticAccountsApi}/certificationlistAPI`;
    }

    apiSelectUserCertificationList() {
        return `${this.collabticAccountsApi}/selectusercertificationsAPI`;
    }

    apiSaveUserCertificationList() {
        return `${this.collabticAccountsApi}/SaveusercertificationsAPI`;
    }

    apiGetuserFollowerFollowing() {
        return `${this.collabticAccountsApi}/GetuserFollowerFollowing`;
    }

    apiUserFollowMethod() {
        return `${this.collabticForumApi}/UserFollowMethod`;
    }

    apiDisclimerstatuslist() {
        return `${this.collabticForumApi}/disclimerstatuslist`;
    }

    /*** Profile ***/

    /** Manage Thread API */

    // Thread Field API
    apiGetThreadFields(version = 1) {
        switch (version) {
            case 1:
                return `${this.collabticAccountsApi}/accountConfigUpdatedV3`;
                break;
            case 2:
                return `${this.collabticV3Api}/account-config/dynamic-fields`;
                break;
        }

    }

    // Opportunity Field API
    apiGetOpportunityFields() {
        return `${this.collabticV3Api}/accounts/contentcreation`;
    }

    // Admin email notification new user signup
    apiSignupAdminNotify() {
        return `${this.collabticV3Api}/support-tickets/signupadminnotify`;
    }

    // Change Signup Email
    apiChangeSignupEmail() {
        return `${this.collabticV3Api}/accounts/changesignupemail`;
    }

    apiGetMarketPlaceFields() {
        return `${this.collabticLocalhost}/market-place`;
    }

    apiGetAllManuals() {
        return `${this.collabticLocalhost}/market-place/manualslistall`;
    }

    apiGetAllManualsTitle() {
        return `${this.collabticLocalhost}/market-place/manualstitlelistall`;
    }

    apiGetAllTrainingsTitle() {
        return `${this.collabticLocalhost}/market-place/trainingstitlelistall`;
    }

    apiGetAllVideosTitle() {
        return `${this.collabticLocalhost}/market-place/videostitlelistall`;
    }

    apiGetAllItemNumber() {
        return `${this.collabticLocalhost}/market-place/getitemnumberlist`;
    }

    apiGetAllTrainingscodeClassList() {
        return `${this.collabticLocalhost}/market-place/getcodeclasslist`;
    }

    apiGetAllReports() {
        return `${this.collabticLocalhost}/market-place/getmarkettransactionsreport`;
    }

    apiGetMarketTrainingsReport() {
        return `${this.collabticLocalhost}/market-place/getmarkettrainingsreport`;
    }

    apiGetMonthlyReportData() {
        return `${this.collabticLocalhost}/market-place/getmonthlyclassrevenue`;
    }

    apiGetAllPurchaseHistory() {
        return `${this.collabticLocalhost}/market-place/shopreport`;
    }

    apiGetAllQuickBookReports() {
        return `${this.collabticLocalhost}/market-place/getquickbooklogs`;
    }

    apiGetAllSubscriptionReports() {
        return `${this.collabticLocalhost}/market-place/getsubscriptionsreport`;
    }

    apiGetManualFields() {
        return `${this.collabticLocalhost}/market-place/manualconfig`;
    }

    apiGetSalesUserData() {
        return `${this.collabticLocalhost}/market-place/getsalesperson`;
    }

    apiGetmanualSalesUserData() {
        return `${this.collabticLocalhost}/market-place/getmanualsalesperson`;
    }

    apiGetParticipantsData() {
        return `${this.collabticLocalhost}/market-place/zoomparticipantlist`;
    }

    apiUpdateSalesPersonApi() {
        return `${this.collabticLocalhost}/market-place/updatesalepersonuser`;
    }

    apiUpdateComment() {
        return `${this.collabticLocalhost}/market-place/updatecomment`;
    }

    apiUpdateManualComment() {
        return `${this.collabticLocalhost}/market-place/updatemanualcomment`;
    }

    apiUpdateManualSalesPersonApi() {
        return `${this.collabticLocalhost}/market-place/updatesalepersonmanual`;
    }

    apiGetKeywordsList() {
        return `${this.collabticLocalhost}/market-place/keywordlist`;
    }

    getVideoLibraryCategoryList() {
        return `${this.collabticLocalhost}/market-place/videocategorylist`;
    }

    getVideoLibraryTagList() {
        return `${this.collabticLocalhost}/market-place/videotaglist`;
    }

    apiAddKeywordsList() {
        return `${this.collabticLocalhost}/market-place/keywordadd`;
    }

    apiVideoCategoryAdd() {
        return `${this.collabticLocalhost}/market-place/videocategoryadd`;
    }

    apiVideoTagAdd() {
        return `${this.collabticLocalhost}/market-place/videotagadd`;
    }

    getVideoCategoryDetail() {
        return `${this.collabticLocalhost}/market-place/getvideocategory`;
    }

    apiUpdateKeywordsList() {
        return `${this.collabticLocalhost}/market-place/keywordupdate`;
    }

    updateCategoryVideoLibrary() {
        return `${this.collabticLocalhost}/market-place/videocategoryupdate`;
    }

    updateTagVideoLibrary() {
        return `${this.collabticLocalhost}/market-place/videotagupdate`;
    }

    apiDeleteKeywordsList() {
        return `${this.collabticLocalhost}/market-place/keyworddelete`;
    }

    apiDeleteVideoCategoryDelete() {
        return `${this.collabticLocalhost}/market-place/videocategorydelete`;
    }

    apiDeleteVideoTagDelete() {
        return `${this.collabticLocalhost}/market-place/videotagdelete`;
    }

    apiUpdateMarketPlaceReminderFields() {
        return `${this.collabticLocalhost}/market-place/trainingsetting`;
    }

    getTrainingEmails() {
        return `${this.collabticLocalhost}/market-place/gettrainingemails`;
    }

    getTransactionEmails() {
        return `${this.collabticLocalhost}/market-place/gettransactionemails`;
    }

    resendTrackingEmail() {
        return `${this.collabticLocalhost}/market-place/resendemail`;
    }

    processTransaction() {
        return `${this.collabticLocalhost}/market-place/processtransaction`;
    }

    apiGetMarketPlaceEditData() {
        return `${this.collabticLocalhost}/market-place/edit`;
    }

    apiGetManualEditData() {
        return `${this.collabticLocalhost}/market-place/editmanual`;
    }

    apiGetMarketPlaceReminderData() {
        return `${this.collabticLocalhost}/market-place/fetchtrainingsetting`;
    }

    apiGetMarketPlaceRegisterUserData() {
        return `${this.collabticLocalhost}/market-place/userslist`;
    }

    apiGetMarketPlaceManualUserData() {
        return `${this.collabticLocalhost}/market-place/manualuserslist`;
    }

    apiGetMarketPlaceEditDomainData() {
        return `${this.collabticLocalhost}/market-place/domainedit`;
    }

    apiGetMarketPlacePoliciesData() {
        return `${this.collabticLocalhost}/market-place/policies`;
    }
    
    apiGetMarketPlaceSurveysData() {
        return `${this.collabticLocalhost}/market-place/surveys`;
    }

    apiGetMarketPlacePolicyData() {
        return `${this.collabticLocalhost}/market-place/policydata`;
    }

    apiGetMarketPlacePoliciesDataByType() {
        return `${this.collabticLocalhost}/market-place/getdatapolicy`;
    }

    apiUpdateMarketPlacePolicyData() {
        return `${this.collabticLocalhost}/market-place/policyupdate`;
    }

    apiDeleteMarketPlacePolicy() {
        return `${this.collabticLocalhost}/market-place/policydelete`;
    }

    getCityStateData() {
        return `${this.collabticLocalhost}/market-place/getcitystatedata`;
    }

    apiGetMarketPlaceEditDomainBannerData() {
        return `${this.collabticLocalhost}/market-place/domainbanner`;
    }

    apiGetMarketPlacePolicyHistory() {
        return `${this.collabticLocalhost}/market-place/policyhistory`;
    }

    apiGetQuizEditData() {
        return `${this.collabticLocalhost}/quiz/quizedit`;
    }

    apiGetTopicEditData() {
        return `${this.collabticLocalhost}/quiz/edittopic`;
    }

    apiGetMarketPlaceData() {
        return `${this.collabticLocalhost}/market-place/list`;
    }

    apiGetManualData() {
        return `${this.collabticLocalhost}/market-place/manualslist`;
    }

    apiGetVideoCategories() {
        return `${this.collabticLocalhost}/market-place/getvideocategories`;
    }

    apiGetVideosByCategory() {
        return `${this.collabticLocalhost}/market-place/getvideosbycategory`;
    }

    apiRemoveVideo() {
        return `${this.collabticLocalhost}/market-place/removevideo`;
    }

    apiGetVideo() {
        return `${this.collabticLocalhost}/market-place/getvideo`;
    }

    apiRepairfyDomainData() {
        return `${this.collabticLocalhost}/market-place/repairfydata`;
    }

    apiGetMarketPlaceDataWithDomainName() {
        return `${this.collabticLocalhost}/market-place/listdomainwithname`;
    }

    apiGetManualDataWithDomainName() {
        return `${this.collabticLocalhost}/market-place/listmanualwithname`;
    }

    apiGetDomainMarketPlaceData() {
        return `${this.collabticLocalhost}/market-place/listdomain`;
    }

    apiGetQuizData() {
        return `${this.collabticLocalhost}/quiz/quizlist`;
    }

    apiGetAllCustomerData() {
        return `${this.collabticLocalhost}/market-place/customerlist`;
    }

    apiGetAllCustomerUsers() {
        return `${this.collabticLocalhost}/market-place/customerusers`;
    }

    apiGetCustomerData() {
        return `${this.collabticLocalhost}/market-place/customerdetail`;
    }

    apiGetBusinessData() {
        return `${this.collabticLocalhost}/market-place/filtercustomer`;
    }

    apiGetQuizDataWithDomainName() {
        return `${this.collabticLocalhost}/quiz/quizlistdomainwithname`;
    }

    apiGetDomainQuizData() {
        return `${this.collabticLocalhost}/quiz/quizdomainlist`;
    }

    apiGetDomainsData() {
        return `${this.collabticLocalhost}/market-place/domains`;
    }

    apiCreateMarketPlace() {
        return `${this.collabticLocalhost}/market-place/add`;
    }

    apiCreateManagevideolibrary() {
        return `${this.collabticLocalhost}/market-place/managevideo`;
    }

    apiManageVideoView() {
        return `${this.collabticLocalhost}/market-place/managevideoview`;
    }

    apiCreateMarketPlaceManual() {
        return `${this.collabticLocalhost}/market-place/addmanual`;
    }

    apiForUserEmail() {
        return `${this.collabticLocalhost}/market-place/useremailcheck`;
    }

    apiForManualUserEmail() {
        return `${this.collabticLocalhost}/market-place/manualuseremailcheck`;
    }

    apiCreateQuizTopic() {
        return `${this.collabticLocalhost}/quiz/addtopic`;
    }

    apiCreateSurvey() {
        return `${this.collabticLocalhost}/market-place/managesurvey`;
    }

    manageSurveyStatus() {
        return `${this.collabticLocalhost}/market-place/managesurveystatus`;
    }

    surveyQuestionList() {
        return `${this.collabticLocalhost}/market-place/questions`;
    }

    moreSurveyQuestionList() {
        return `${this.collabticLocalhost}/market-place/surveyquestionslist`;
    }

    addQuestionsToSurvey() {
        return `${this.collabticLocalhost}/market-place/addquestionstosurvey`;
    }

    manageMarketingeSetting() {
        return `${this.collabticLocalhost}/market-place/managemarketingesetting`;
    }

    removeQuestionFromSurvey() {
        return `${this.collabticLocalhost}/market-place/removequestionfromsurvey`;
    }

    apiUpdateQuizTopic() {
        return `${this.collabticLocalhost}/quiz/updatetopic`;
    }

    apiForZoomSettingUpdate() {
        return `${this.collabticLocalhost}/market-place/zoomsettingupdate`;
    }

    apiForInformedUsersUpdate() {
        return `${this.collabticLocalhost}/market-place/informedusersupdate`;
    }

    apiForNotificationSettingUpdate() {
        return `${this.collabticLocalhost}/market-place/notificationsettingupdate`;
    }

    apiForZoomConfigurationUpdate() {
        return `${this.collabticLocalhost}/market-place/zoomconfigurationupdate`;
    }

    apiForMarketplaceSettingsUpdate() {
        return `${this.collabticLocalhost}/market-place/updatemarketplacesettings`;
    }

    apiForLoadZoomSetting() {
        return `${this.collabticLocalhost}/market-place/zoomsettingget`;
    }

    apiForLoadMarketplaceSettings() {
        return `${this.collabticLocalhost}/market-place/getmarketplacesettings`;
    }

    apiForLoadInformedUsers() {
        return `${this.collabticLocalhost}/market-place/informedusers`;
    }

    apiForLoadPaymentSetting() {
        return `${this.collabticLocalhost}/payment/paymentsettingget`;
    }

    apiForLoadEmailSetting() {
        return `${this.collabticLocalhost}/market-place/emailsettings`;
    }

    apiForLoadShippingCost() {
        return `${this.collabticLocalhost}/market-place/shippingcost`;
    }

    apiForUpdateEmailSetting() {
        return `${this.collabticLocalhost}/market-place/emailsettingsupdate`;
    }

    apiDuplicateQuizTopic() {
        return `${this.collabticLocalhost}/quiz/duplicatetopic`;
    }

    apiDeleteQuizTopic() {
        return `${this.collabticLocalhost}/quiz/deletetopic`;
    }

    apiCreateQuiz() {
        return `${this.collabticLocalhost}/quiz/quizadd`;
    }

    apiUpdateQuiz() {
        return `${this.collabticLocalhost}/quiz/quizupdate`;
    }

    apiGetQuizTopic() {
        return `${this.collabticLocalhost}/quiz/listtopic`;
    }

    apiGetSurvey() {
        return `${this.collabticLocalhost}/market-place/surveylist`;
    }

    apiAddQuestionInSurvey() {
        return `${this.collabticLocalhost}/market-place/managesurveyquestion`;
    }

    apiGetSurveyDetail() {
        return `${this.collabticLocalhost}/market-place/survey`;
    }

    saveFeedback() {
        return `${this.collabticLocalhost}/market-place/savefeedback`;
    }

    feedbackList() {
        return `${this.collabticLocalhost}/market-place/feedbacklist`;
    }

    feedbackStatus() {
        return `${this.collabticLocalhost}/market-place/feedbackstatus`;
    }

    manageSurveyQuestionsOrder() {
        return `${this.collabticLocalhost}/market-place/managesurveyquestionsorder`;
    }

    deleteSurvey() {
        return `${this.collabticLocalhost}/market-place/removesurvey `;
    }

    removeQuestion() {
        return `${this.collabticLocalhost}/market-place/removequestion `;
    }

    manageReminderEmailText() {
        return `${this.collabticLocalhost}/market-place/managereminderemailtext `;
    }

    apiGetQuizTopicWithRecords() {
        return `${this.collabticLocalhost}/quiz/topiclistdata`;
    }

    apiManualTax() {
        return `${this.collabticLocalhost}/market-place/manualtax`;
    }

    apiTrainingTax() {
        return `${this.collabticLocalhost}/market-place/trainingtax`;
    }

    apivalidateShippingAddress() {
        return `${this.collabticLocalhost}/market-place/validateshippingddress`;
    }

    getPaymentkeys() {
        return `${this.collabticLocalhost}/market-place/getpaymentkeys`;
    }

    setPaymentkeys() {
        return `${this.collabticLocalhost}/market-place/setpaymentkeys`;
    }

    apiForGetCart() {
        return `${this.collabticLocalhost}/cart/cartdetails`;
    }

    updateCartItems() {
        return `${this.collabticLocalhost}/cart/updatecartitems`;
    }

    updateManualStatus() {
        return `${this.collabticLocalhost}/market-place/updatemanualstatus`;
    }

    updateQbItemStatus() {
        return `${this.collabticLocalhost}/market-place/updateqbitemstatus`;
    }

    updateCartItemsWithDetails() {
        return `${this.collabticLocalhost}/cart/updatecartitemswithdetails`;
    }

    emptyCart() {
        return `${this.collabticLocalhost}/cart/clearcart`;
    }

    updateCartForm() {
        return `${this.collabticLocalhost}/cart/updatecartforms`;
    }

    updateBusinessNew() {
        return `${this.collabticLocalhost}/market-place/createcustomer`;
    }

    manageAutoshopSubscriber() {
        return `${this.collabticLocalhost}/market-place/manageautoshopsubscriber`;
    }

    getAutoshopSubscribers() {
        return `${this.collabticLocalhost}/market-place/getautoshopsubscribers`;
    }

    manageAutoshopSubscriberStatus() {
        return `${this.collabticLocalhost}/market-place/manageautoshopsubscriberstatus`;
    }

    emailAutoshopSubscribers() {
        return `${this.collabticLocalhost}/market-place/emailautoshopsubscribers`;
    }

    checkCustomerPhone() {
        return `${this.collabticLocalhost}/market-place/checkcustomerexists`;
    }

    removeTrainingParticipant() {
        return `${this.collabticLocalhost}/market-place/removetrainingparticipant`;
    }

    updateSalesPersonEmail() {
        return `${this.collabticLocalhost}/market-place/updatesalesrepmail`;
    }

    getAllTrainings() {
        return `${this.collabticLocalhost}/market-place/get-all-trainings`;
    }

    importExcel() {
        return `${this.collabticLocalhost}/market-place/importexcel`;
    }

    checkCustomerName() {
        return `${this.collabticLocalhost}/market-place/checkcustomerexistsbyname`;
    }

    apiForCustomerAdd() {
        return `${this.collabticLocalhost}/market-place/customeradd`;
    }

    apiForCompanyAdd() {
        return `${this.collabticLocalhost}/market-place/companyadd`;
    }

    apiForCompanyAddData() {
        return `${this.collabticLocalhost}/market-place/companyadddata`;
    }

    apiForCompanyAddressAddData() {
        return `${this.collabticLocalhost}/market-place/companyaddressadddata`;
    }

  apiForCompanyAddressAddDataId() {
    return `${this.collabticLocalhost}/market-place/companyaddressadddataid`;
  }
    apiForCompanyAddressUpdate() {
        return `${this.collabticLocalhost}/market-place/companyaddressupdate`;
    }

    apiForCustomerFileUpload() {
        return `${this.collabticLocalhost}/market-place/customerfileupload`;
    }

    apiForCustomerUpdate() {
        return `${this.collabticLocalhost}/market-place/customerupdate`;
    }

    apiForCustomerDelete() {
        return `${this.collabticLocalhost}/market-place/customerdelete`;
    }

    apiForRefundPayment() {
        return `${this.collabticLocalhost}/payment/paymentrefund`;
    }

    apiForRefundManualPayment() {
        return `${this.collabticLocalhost}/payment/manualpaymentrefund`;
    }

    apiForReportsColumns() {
        return `${this.collabticLocalhost}/market-place/savecolumnsjson`;
    }

    apiForPartialRefundPayment() {
        return `${this.collabticLocalhost}/payment/transactionrefundnew`;
        // return `${this.collabticLocalhost}/payment/transactionrefund`;
    }

    refundResendEmail() {
        return `${this.collabticLocalhost}/payment/refundresendemail`;
    }

    apiForRefundHistory() {
        return `${this.collabticLocalhost}/payment/refundhistory`;
    }

    apiUpdateDomainMarketPlace() {
        return `${this.collabticLocalhost}/market-place/domainupdate`;
    }

    apiGetProducts() {
        return `${this.collabticLocalhost}/market-place/products`;
    }

    apiCreateSubscription() {
        return `${this.collabticLocalhost}/market-place/createsubscription`;
    }

    apiCreatecard() {
        return `${this.collabticLocalhost}/market-place/createcreditcard`;
    }

    apiDeletecard() {
        return `${this.collabticLocalhost}/market-place/deletecreditcard`;
    }

    getPaymentMethods() {
        return `${this.collabticLocalhost}/market-place/getpaymentmethods`;
    }

    setCreditcardPrimary() {
        return `${this.collabticLocalhost}/market-place/setcreditcardprimary`;
    }

    apiCancelSubscription() {
        return `${this.collabticLocalhost}/market-place/cancelsubscription`;
    }

    apiResumeSubscription() {
        return `${this.collabticLocalhost}/market-place/resumesubscription`;
    }

    apiGetSubscription() {
        return `${this.collabticLocalhost}/market-place/getsubscription`;
    }

    apiGetsubscriptions() {
        return `${this.collabticLocalhost}/market-place/getsubscriptions`;
    }

    apiGetsubscriptionInvoiceDetail() {
        return `${this.collabticLocalhost}/market-place/subscriptiondetail`;
    }

    getSubscriptionLogs() {
        return `${this.collabticLocalhost}/market-place/getsubscriptionlogs`;
    }

    apiUpdateDomainBannerMarketPlace() {
        return `${this.collabticLocalhost}/market-place/domainbannerupdate`;
    }

    apiGetDomainBusinessTypeMarketPlace() {
        return `${this.collabticLocalhost}/market-place/domainbusinesstypes`;
    }

    apiUpdateRepairfyDomainMarketPlace() {
        return `${this.collabticLocalhost}/market-place/repairfydomainupdate`;
    }

    // Thread Creation API
    apiDeleteMarketPlace() {
        return `${this.collabticLocalhost}/market-place/delete`;
    }

    apiDeleteMarketPlacePermanent() {
        return `${this.collabticLocalhost}/market-place/permanentdelete`;
    }

    apiDeleteManualPermanent() {
        return `${this.collabticLocalhost}/market-place/permanentdeletemanual`;
    }

    apiRestoreMarketPlace() {
        return `${this.collabticLocalhost}/market-place/restore`;
    }

    apiDeleteManual() {
        return `${this.collabticLocalhost}/market-place/deletemanual`;
    }

    apiRestoreManual() {
        return `${this.collabticLocalhost}/market-place/restoremanual`;
    }

    apiSetIsNewFalse() {
        return `${this.collabticLocalhost}/market-place/viewuser`;
    }

    apiSetIsNewFalseManual() {
        return `${this.collabticLocalhost}/market-place/viewmanual`;
    }

    apiDeleteQuiz() {
        return `${this.collabticLocalhost}/quiz/quizdelete`;
    }

    apiUpdateMarketPlace() {
        return `${this.collabticLocalhost}/market-place/update`;
    }

    apiUpdateManual() {
        return `${this.collabticLocalhost}/market-place/updatemanual`;
    }

    apiCreateUserMarketPlace() {
        return `${this.collabticLocalhost}/market-place/useradd`;
    }

    apiCreateUserManualBooking() {
        return `${this.collabticLocalhost}/market-place/useraddmanual`;
    }

    apiPurchaseSeatsMarketPlace() {
        return `${this.collabticLocalhost}/market-place/purchaseseat`;
    }

    apiUserInfoUpdate() {
        return `${this.collabticLocalhost}/market-place/userinfoupdate`;
    }

    apiManualUserInfoUpdate() {
        return `${this.collabticLocalhost}/market-place/manualuserinfoupdate`;
    }

    apiGetMasterData() {
        return `${this.collabticLocalhost}/market-place/dropdownlistdata`;
    }

    apiGetStateData() {
        return `${this.collabticLocalhost}/market-place/statelistdatabycountry`;
    }

    // Thread Creation API
    apiCreateThread() {
        return `${this.collabticForumApi}/createThreadV2`;
    }

    // Thread Update API
    apiUpdateThread() {
        return `${this.collabticForumApi}/updateThreadV2`;
    }

    // Thread Push Api
    apiThreadPush() {
        return `${this.pushApi}/SendbulkPushFromApp`;
    }

    // Document Notification Api
    apiDocumentNotification() {
        return `${this.resourceApi}/sendingdocumentnotification`;
    }

    // ADAS Notification Api
    apiADASNotification() {
        return `${this.collabticV3Api}/adas/push`;
    }

    // Document Approval Notification Api
    apiDocumentApprovalNotification() {
        return `${this.pushApi}/pushMessageStatusChange`;
    }

    // Announcement Push Api
    apiAnnouncementPush() {
        return `${this.pushApi}/SendbulkPushAnnouncement`;
    }

    // Document/Announcement Update API
    apiUpdateTechInfo() {
        return `${this.resourceApi}/UpdateManualsandannouncement`;
    }

    apiGetGroupAndDirectMessagewithCount() {
        return `${this.collabticForumApi}/GetChatListing`;
    }

    /*** Thread-Post ***/

    // get thread detail
    apiGetthreadDetailsios() {
        return `${this.collabticForumApi}/GetthreadDetailsios`;
    }

    apiAtomicUpdateSolr() {
        return `${this.collabticForumApi}/AtomicUpdateSolr`;
    }

    // get post list
    apiPostList() {
        return `${this.collabticForumApi}/PostListAPI`;
    }
     // get post list
    apiRemoveactivethreadusers() {
        return `${this.collabticForumApi}/removeactivethreadusers`;
    }

    // new post
    apiReplyPost() {
        return `${this.collabticForumApi}/ReplyPostApi`;
    }

    apiAddLikesChatbotResponse() {
        return `${this.collabticV3Api}/forum/addlikeschatbotresponse`;
    }

    // Updatetechsupportreason
    apiUpdatetechsupportreason() {
        return `${this.collabticForumApi}/Updatetechsupportreason`;
    }

    // techsupportreasondata
    apitechsupportreasondata() {
        return `${this.collabticForumApi}/techsupportreasondata`;
    }


    // Save TechSupport Presets
    apiSaveTechSupportPresets() {
        return `${this.collabticForumApi}/SaveTechSupportPresets`;
    }

    //Preset List
    apiPresetList() {
        return `${this.collabticForumApi}/PresetList`;
    }

    // new post
    apiUpdatePost() {
        return `${this.collabticForumApi}/updatePostAPI`;
    }

    // close thread
    apiCloseThread() {
        return `${this.collabticForumApi}/CloseThreadAPI`;
    }

    apiValidateCloseThread() {
        return `${this.collabticForumApi}/ValidateCloseThread`;
    }


    apigetAllTagUsersList() {
        return `${this.collabticDashApi}/getAllTagUsersList`;
    }

    apiupdateTagUsersList() {
        return `${this.collabticForumApi}/SaveTaggedUsers`;
    }

    GetAlldomainUsersAPI() {
        return `${this.collabticForumApi}/GetAlldomainUsersAPI`;
    }

    // re-open thread
    apiReopenThread() {
        return `${this.collabticForumApi}/updateclosethreads`;
    }

    // delete thread/post
    apiDeleteThreadPost() {
        return `${this.collabticApi}/threadpost/threadpostupdatedeletestatus`;
    }

    deletePresetAPI() {
        return `${this.collabticForumApi}/DeletePresets`;
    }

    // delete thread/post
    apiSolutionStatusAPI() {
        return `${this.collabticForumApi}/SolutionStatusAPI`;
    }

    // Thread AddLike, Pin and OnePlus
    apiAddLikePinOnePlus() {
        return `${this.collabticForumApi}/AddLikePins`;
    }

    // Send Reminder (MOBILE PUSH)
    apiSendPushtoMobile() {
        return `${this.notificationApi}/sendPushtoMobile`;
    }

    // Add Reminder
    apiAddReminder() {
        return `${this.collabticForumApi}/SendRemindertoUsers`;
    }

    // Send Reminder (MOBILE PUSH)
    apiSendReminder() {
        return `${this.pushApi}/SendRemindertBulkPush`;
    }

    // Thread and post dashboard users
    apiDashboardUsersList() {
        let platformId = localStorage.getItem("platformId");
        if (platformId == PlatFormType.Collabtic) {
            return `${this.collabticForumApi}/dashboardusers`;
        } else {
            return `${this.collabticForumApi}/dashboardusersAPI`;
        }
    }

    apiSaveVision2025Form() {
        return `${this.collabticLocalhost}/market-place/savevision`;
  }

  apiUpdateVision2025() {
    return `${this.collabticLocalhost}/market-place/updatelistvision`;
  }

  apiGetVisionReports() {
    return `${this.collabticLocalhost}/market-place/getvisionreport`;
  }

  apiSaveRaffleForm() {
    return `${this.collabticLocalhost}/market-place/saveraffle`;
  }

  apiListGiveaway() {
    return `${this.collabticLocalhost}/market-place/listgiveaway`;
  }
    apiGetvisionmanuallist() {
        return `${this.collabticLocalhost}/market-place/getvisionmanuallist`;
    }

    apiGetListVision() {
        return `${this.collabticLocalhost}/market-place/listvision`;
    }

    apiGetManualPdfLink() {
        return `${this.collabticLocalhost}/market-place/getmanualpdf`;
    }

    apiDeleteVision() {
        return `${this.collabticLocalhost}/market-place/deletevision`;
  }

  apiSendVisionMail() {
    return `${this.collabticLocalhost}/market-place/sendvisionmail`;
  }

  apiDeleteGiveaway() {
    return `${this.collabticLocalhost}/market-place/deletegiveaway`;
    }

    /*** SaveAssigneeRoles ***/
    apiSaveAssigneeRoles() {
        return `${this.collabticForumApi}/SaveAssigneeRoles`;
    }

    // get post list
    apiTechsupportHistory() {
        return `${this.collabticForumApi}/TechsupportHistory`;
    }

    // get post list
    apishowthreadreopenhistory() {
        return `${this.collabticForumApi}/showthreadreopenhistory`;
    }

    /*** Thread-Post ***/
    apiAddMementToGroup() {
        return `${this.collabticForumApi}/AddMemberstochat`;
    }

    // Thread Creation API
    apiCreateDoc() {
        return `${this.resourceApi}/CreateManualsandAnnouncement`;
    }

    // get disclimer
    apiGetuserdisclimer() {
        return `${this.collabticApi}/user/Getuserdisclimer`;
    }

    // get disclimer
    apiValidateNewThreadOption() {
        return `${this.collabticForumApi}/ValidateNewThreadOption`;
    }

    // get disclimer
    apiSaveuserdisclimerstatus() {
        return `${this.collabticForumApi}/saveuserdisclimerstatus`;
    }

    // Manage Adas Procedure
    apiManageAdas() {
        return `${this.collabticV3Api}/adas/manage`;
    }

    /*** Announcement ***/

    // get announcment detail
    apiGetAnnouncementDetail() {
        return `${this.resourceApi}/GetManualDetails`;
    }

    apigetUploadMediaStatus() {

        if (this.platformInfo != "1") {
            return `${this.collabticForumApi}/getawsvideojobstatus`;
        } else {
            return `${this.collabticForumApi}/getawsvideojobstatusV2`;
        }
    }

        apigetUploadMediaStatusNew() {

        /*if (this.platformInfo != "1") {
            return `${this.collabticForumApi}/getawsvideojobstatus`;
        } else {
            return `${this.collabticForumApi}/getawsvideojobstatusV2`;
        }*/

        let platformId = localStorage.getItem("platformId");
        if (platformId == PlatFormType.Collabtic) {
            return `${this.collabticV3Api}/media/medisconvertjobstatus`;
        } else if (platformId == PlatFormType.MahleForum) {
            return `${this.mahleV2Api}/managecontent/medisconvertjobstatus`;
        } else if (platformId == PlatFormType.CbaForum) {
            return `${this.collabticV3Api}/media/medisconvertjobstatus`; 
        } 
        else{
             return `${this.collabticV3Api}/media/medisconvertjobstatus`;
        }
    }

    // announcment AddLike
    apiResourceAddLike() {
        return `${this.resourceApi}/AddLikePins`;
    }

    // announcment AddLike
    apiMigrateDoctoKA() {
        return `${this.resourceApi}/migrateDoctoKA`;
    }

    // announcement dashboard
    apiLoadAnnounceDashboard() {
        return `${this.collabticForumApi}/LoadAnnounceDashboard`;
    }

    // announcement dashboard
    apiLoadKADashboard() {
        return `${this.collabticForumApi}/LoadKADashboard`;
    }

    // announcement dashboard
    apiDismissManuals() {
        return `${this.resourceApi}/DismissManuals`;
    }

    // announcement archive
    apiArchiveAnnouncements() {
        return `${this.resourceApi}/archiveAnnouncement`;
    }

      // announcement archive
      apiUnArchiveAnnouncements() {
        return `${this.resourceApi}/Unarchiveannouncement`;
    }

    // announcement archive
    apiUpdateUserScrollPopup() {
        return `${this.collabticAccountsApi}/UpdateUserScrollPopup`;
    }

    // Get Product/Vehicle Banner Image
    apiGetBanner() {
        return `${this.productmakeApi}/getBannerImage`;
    }

    // update helpcontent
    apitooltipconfigWeb(): string {
        return `${this.collabticAccountsApi}/tooltipconfigWeb`;
    }

    // Get SIB Lists
    apiGetSibLists() {
        return `${this.demoGtsMahale}/sib/SIBListing`;
    }

    // Create SIB
    apiCreateSIB() {
        return `${this.demoGtsMahale}/sib/saveSIB`;
    }

    // GEt SIB Details
    apiGetSibDetail() {
        return `${this.demoGtsMahale}/sib/SIBDetailsAPI`;
    }

    // Like & Pin Actions
    apiSibLikePinAction() {
        return `${this.demoGtsMahale}/sib/AddLikePins`;
    }

    // SIB Notification Api
    apiSIBNotification() {
        return `${this.demoGtsMahale}/sib/sendingsibnotification`;
    }

    // Delate document
    apiDeleteDocument() {
        return `${this.resourceApi}/DeleteDocumentInfo`;
    }

    // Delate document
    apiUpdatemetricsflag() {
        return `${this.resourceApi}/updatemetricsflag`;
    }

    // Save PPFR Form API
    apiSavePPFRFormData() {
        return `${this.collabticForumApi}/EscFeedbackFormAction`;
    }

    // PPFR Form detail API
    apiGetEscalateThreadDetails() {
        return `${this.collabticForumApi}/FindEscFeedbackFormDetails`;
    }

    // dealer area and dealer code
    apiUsagemetricsfiltercontent() {
        return `${this.collabticForumApi}/Usagemetricsfiltercontent`;
    }

    // Get Video Job Status
    apiVideoJobStatus() {
        return `${this.jobStatusApi}`;
    }

    // Get Video Job Status
    apiVideoJobStatusS3() {
        let platformId = localStorage.getItem("platformId");
        if (platformId == PlatFormType.Collabtic) {
            return `${this.collabticV3Api}/media/medisconvertjobstatus`;
        } else if (platformId == PlatFormType.MahleForum) {
            return `${this.mahleV2Api}/managecontent/medisconvertjobstatus`;
        } else if (platformId == PlatFormType.CbaForum) {
            return `${this.collabticV3Api}/media/medisconvertjobstatus`; 
        } 
        else{
             return `${this.collabticV3Api}/media/medisconvertjobstatus`;
        }
       
    }

    // dealer area and dealer code
    apiManageTokBoxsession() {
        return `${this.collabticForumApi}/ManageTokBoxsession`;
    }

    /*** KnowledgeBase API Start ***/
    // Get KnowledgeBase List
    apiGetKnowledgeBaseList() {
        return `${this.knowledgeBaseApi}/KnowledgeBaseList`;
    }

    // Knowledge Base Creation API
    apiCreateKB() {
        return `${this.knowledgeBaseApi}/SaveKnowledgeBase`;
    }

    // Knowledge Base Creation API
    apiViewKB() {
        return `${this.collabticForumApi}/ViewContentDetails`;
    }

    // Delate KB
    apiDeleteKB() {
        return `${this.knowledgeBaseApi}/DeleteKBInfo`;
    }

    // Social Actions KB
    apiSocialActionKB() {
        return `${this.knowledgeBaseApi}/AddLikePins`;
    }

    //
    apiTVSSSOLogin() {
        return `${this.collabticAccountsApi}/TVSLoginSSO`;
    }

    //
    apiTVSSSODealerLogin() {
        return `${this.collabticAccountsApi}/TVSDealerSSO`;
    }

    // Get dealer Info
    apiTVSSSOGetEmployeeInfo() {
        return `${this.collabticAccountsApi}/GetDealerEmployeeInfo`;
    }
    
    // Get dealer Info
    apiTVSverifyotp() {
        return `${this.collabticAccountsApi}/verifyotp`;
    }
  
    // Get dealer Info
    apiTVSsendotp() {
        return `${this.collabticAccountsApi}/sendotpmethod`;
    }

    // Get dealer Info
    apiTVSSSOGetDealerInfo() {
        return `${this.collabticAccountsApi}/GetDealerInfo`;
    }

    apiLeaderBoard() {
        return `${this.collabticForumApi}/getleaderboardV2`;
    }

    apiTechSupportChart() {
        return `${this.collabticForumApi}/ViewDashboardByThreadCategory`;
    }

    getMfgMakeChart() {
        return `${this.collabticDashApi}/GetMfgMakeChart`;
    }

    apiUserActivities() {
        return `${this.collabticForumApi}/Usagemetrics`;
    }

    // Get DTC Lists
    apiDtcList() {
        return `${this.collabticForumApi}/DtcTypeLists`;
    }

    // GET DTC Create URL
    apiGetCreateDTC() {
        return `${this.collabticForumApi}/CreateErrorCode`;
    }

    // GET DTC Create URL
    apiEscalationDealerImport() {
        return `${this.collabticAccountsApi}/EscalationDealerImport`;
    }

    apiEscalationDealerImportValidate() {
        return `${this.collabticAccountsApi}/EscalationDealerImportV2`;
    }

    apiEscalationDealerImportValidateV3() {
        return `${this.collabticAccountsApi}/EscalationDealerImportV3`;
    }

    //
    apiNewBusinessSetup() {
        return `${this.collabticAccountsApi}/NewBusinessSetup`;
    }

    //
    apiSaveBusinessOptions() {
        return `${this.collabticAccountsApi}/SaveBusinessOptions`;
    }

    //
    apiBusinessInviteNewMembers() {
        return `${this.collabticAccountsApi}/BusinessInviteNewMembers`;
    }

    //
    apiDecodeEmailaddress() {
        return `${this.collabticAccountsApi}/DecodeEmailaddress`;
    }

    //
    apiUpdateConfigSettings() {
        return `${this.collabticForumApi}/UpdateChatConfigSettings`;
    }

    // get user
    apiGetworkstramsusersparticipants() {
        return `${this.collabticForumApi}/GetworkstramsusersparticipantsAPI`;
    }

    // get user
    apiGetContentTypeList() {
        return `${this.collabticForumApi}/GetContentTypeList`;
    }

    // apiGetloginactivity
    apiGetloginactivity() {
        return `${this.collabticAccountsApi}/loginactivity`;
    }

    techGeoLocationAPI() {
        //return `${this.collabticV3Api}/market-place/getusergeolocations`;
        return `${this.collabticV3Api}/services/getusergeolocations`;
    }

    apiServiceList() {
        return `${this.collabticV3Api}/services/list`;
    }

    apiServiceListInfo() {
        return `${this.collabticV3Api}/services/listinfo`;
    }

    apiServiceListByStatus() {
        return `${this.collabticV3Api}/services/service-list`;
    }

    apiServiceUpdate() {
        return `${this.collabticV3Api}/services/service-update`;
    }

    apiBoardSettings() {
        return `${this.collabticV3Api}/board-settings/list`;
    }

    apiDispatchSettings() {
        return `${this.collabticV3Api}/dispatch-settings/list`;
    }

    apiWorkOrderTypeList() {
        return `${this.collabticV3Api}/support-tickets/work-order-types`;
    }

    apiManageMarketData() {
        return `${this.collabticV3Api}/support-tickets/market-data-manage`;
    }

    apiGetLocationtData() {
        return `${this.collabticV3Api}/accounts/locationdata`;
    }

    apiSalesRepList() {
        return `${this.collabticV3Api}/support-tickets/sales-rep-list`;
    }

    apiWorkOrderPaymentMethods() {
        return `${this.collabticV3Api}/support-tickets/payment-methods`;
    }

    apiWorkOrderPaymentTerms() {
        return `${this.collabticV3Api}/support-tickets/payment-terms`;
    }

    apiWorkOrderData() {
        return `${this.collabticV3Api}/support-tickets/work-orders-data`;
    }

    apiWorkOrderSendEstimate() {
        return `${this.collabticV3Api}/support-tickets/send-estimation`;
    }

    apiGetWorkOrderEstimateList() {
        return `${this.collabticV3Api}/support-tickets/estimation-list`;
    }

    apiManageThreadSurvey() {
        return `${this.collabticV3Api}/feedback/thread-survey`;
    }

    apiThreadCloseEmail() {
        return `${this.collabticV3Api}/feedback/thread-close`;
    }

    apiGetCustomerFeedbackList() {
        return `${this.collabticV3Api}/feedback/customer-feedback`;
    }

    apiGetCustomerFeedbackMetrics() {
        return `${this.collabticV3Api}/feedback/feedback-metrics`;
    }

    apiAccecptEstimate() {
        return `${this.collabticV3Api}/support-tickets/accept-estimate`;
    }

    apiWorkOrderSendInvoice() {
        return `${this.collabticV3Api}/support-tickets/send-invoice`;
    }

    apiWorkOrderUpdate() {
        return `${this.collabticV3Api}/support-tickets/work-order-update`;
    }

    apiServiceJobTypeList() {
        return `${this.collabticV3Api}/services/type-list`;
    }

    apiShopList() {
        return `${this.collabticV3Api}/shop`;
    }

    apiStatusList() {
        return `${this.collabticV3Api}/services/schedule-status-list`;
    }

    apiManageService() {
        return `${this.collabticV3Api}/services/manage`;
    }

    apiUpdateDispatchFieldSolr() {
        return `${this.collabticV3Api}/services/updatesolrdata`;
    }

    apiManageServiceCatg() {
        return `${this.collabticV3Api}/service-type/manage`;
    }

    apiServiceContactList() {
        return `${this.collabticV3Api}/service-contact`;
    }

    apiManageServiceContact() {
        return `${this.collabticV3Api}/service-contact/manage`;
    }

    apiManageServiceShop() {
        return `${this.collabticV3Api}/shop/manage`;
    }

    apiManageAttributeAPI() {
        return `${this.collabticV3Api}/shop/manage-customer-attribute`;
    }

    apiManageCustomerDiscountAPI() {
        return `${this.collabticV3Api}/shop/manage-customer-discount`;
    }

    apiCheckDuplicate() {
        return `${this.collabticV3Api}/services/check-duplicate`;
    }

    apiServiceCategory() {
        return `${this.collabticV3Api}/service-type`;
    }

    apiVehiclebyVIN() {
        return `${this.productmakeApi}/VehicleInfobyVIN`;
    }

    apiModels() {
        return `${this.modalapi}/getproductmatrixModelsbyMake`;
    }

    apiStandardReportLists() {
        return `${this.collabticV3Api}/repairify/list`;
    }

    apiManageReport() {
        return `${this.collabticV3Api}/repairify/manage`;
    }

    apiManageAltMfgNameAPI() {
        return `${this.collabticApi}/accounts/alternatemfg`;
    }

    apiGetMfgList() {
        return `${this.productInfoApi}/getManufacturerList`;
    }

    // Roles and Permissions
    apiRolesAndPermissions() {
        return `${this.collabticDashApi}/accesslevelByRole`;
    }

    // Update Roles and Permissions
    updateApiRolesAndPermissions() {
        return `${this.collabticDashApi}/UpdateaccesslevelByRole`;
    }

    // Reapirify Import
    apiRepairifyImport() {
        return `${this.collabticV3Api}/repairify/upload`;
    }

    // CBT V3 API Push
    apiV3SendPush() {
        return `${this.collabticV3Api}/services/sendpushdispatch`;
        //return `${this.collabticV3Api}/services/send-push-message`;
    }

    apiV3SendROPush() {
        return `${this.collabticV3Api}/support-tickets/sendpushmessages`;
    }

    apiV3SendCalproPush() {
        return `${this.collabticV3Api}/support-tickets/sendcallpropushmessages`;
    }

    //save team
    apiSaveTechSupportTeams() {
        return `${this.collabticForumApi}/SaveTechSupportTeams`;
    }

    //check team
    apiCheckSupportTeamName() {
        return `${this.collabticForumApi}/CheckSupportTeamName`;
    }

    //assign
    apiUpdateThreadTechSupport() {
        return `${this.collabticForumApi}/UpdateThreadTechSupport`;
    }

    //assign
    apiTechSupportMenus() {
        return `${this.collabticForumApi}/TechSupportMenus`;
    }

    apiTechSupportPriorityDataList() {
        return `${this.collabticForumApi}/TechSupportPriorityDataList`;
    }

    apiupdateTechSupportPriorityData() {
        return `${this.collabticForumApi}/updateTechSupportPriorityData`;
    }

    // status change
    apiDocApprovalStatusChange(): string {
        return `${this.resourceApi}/StatusChangeUpdate`;
    }

    apiSharedFixApprovalStatusChange() {
        return `${this.collabticForumApi}/statusChangeUpdate`;
    }

    // status change
    apiKaizenApprovalStatusChange(): string {
        return `${this.kaizenApi}/StatusChangeUpdate`;
    }

    // save
    apiKaizenUpdateApi() {
        return `${this.kaizenApi}/save`;
    }

    // list
    apiKaizenListDetail() {
        return `${this.kaizenApi}/list`;
    }

    // status list
    apiKaizenGetUserStatusList() {
        return `${this.kaizenApi}/getUserStatusList`;
    }

    // Get Opportunity Lists
    apiOpportunityList() {
        return `${this.collabticV3Api}/opportunity/list`;
    }

    // Manage Opportunity API (Create/Edit)
    apiManageOpportunity() {
        return `${this.collabticV3Api}/opportunity/manage`;
    }

    // escalation
    apiManualEscalationAction() {
        return `${this.escalationV2Api}/ManualEscalationAction`;
    }

    // Update Mfg Name Api
    apiUpdateMfgName() {
        return `${this.resourceApi}/UpdateMfgNameUpdate`;
    }

    // Get Recall Data
    apiRecallData() {
        return `${this.collabticV3Api}/repairify/recall`;
    }

    // Manage Part System
    apiGetKeyWordPriority() {
        return `${this.collabticForumApi}/getKeyWordPriority`;
    }

    //Create Bug or Feature
    apiCreatebugfeature() {
        return `${this.supportApi}/Createbugfeature`;
    }

    //List out the bug or feature
    apiBugsFeatureList() {
        return `${this.supportApi}/BugsFeatureList`;
    }

    //Reply post api
    apibugfeatureReplypost() {
        return `${this.supportApi}/ReplyPostApi`;
    }

    //Postlist
    apibugfeaturepostapicall() {
        return `${this.supportApi}/PostListAPI`;
    }

    //updatePost
    apibugfeatureupdatepost() {
        return `${this.supportApi}/updatePostAPI`;
    }

    // system setting
    apiGetSystemSettings() {
        return `${this.collabticApi}/accounts/getSystemSettings`;
    }
    // system setting
    apiGetWaitingapproval() {
        return `${this.collabticApi}/accounts/Getwaitingapproval`;
    }
    apiUpdatewaitingapproval() {
        return `${this.collabticApi}/accounts/Updatewaitingapproval`;
    }
    // system setting
    apiGetAllLogoutoptions() {
        return `${this.collabticApi}/accounts/getAllLogoutoptions`;
    }

    apiUpdateSystemSettings() {
        return `${this.collabticApi}/accounts/UpdateSystemSettings`;
    }

    // system setting
    apiGetthreadstatusupdates() {
        return `${this.collabticApi}/accounts/Getthreadstatusupdates`;
    }

    apiUpdatealterthreadstatus() {
        return `${this.collabticApi}/accounts/updatealterthreadstatus`;
    }

    apiUpdateSystemSettingsNew() {
        return `${this.collabticAccountsApiv2}/updatesystemsettings`;
    }

    apiUpdatelogoutOption() {
        return `${this.collabticAccountsApi}/UpdatelogoutOption`;
    }

    apiUpdatelogoutImidiate() {
        return `${this.collabticAccountsApi}/UpdatelogoutImidiate`;
    }

    apiGetSystemSettingsMenus() {
        return `${this.collabticApi}/accounts/getSystemSettingsMenus`;
    }

    apiGetRolesMappingList() {
        return `${this.collabticApi}/accounts/getRolesMappingList`;
    }

    apiGetAccountypeandBussRoles() {
        return `${this.collabticApi}/accounts/AccountypeandBussRoles`;
    }

    apiUpdateBussRoleSettings() {
        return `${this.collabticApi}/accounts/UpdateBussRoleSettings`;
    }

    apiUpdateDefaultTeam() {
        return `${this.collabticApi}/accounts/UpdateDefaultTeam`;
    }

    apiGetShippingcost(domainId) {
        return `${this.collabticApi}/getshippingcost?domainId=${domainId}`;
    }

    apiUpdateShippingcost() {
        return `${this.collabticApi}/shippingcostupdate`;
    }

    // User Settings Menu API
    apiGetUserSettingsMenu() {
        return `${this.collabticV3Api}/accounts/get-user-settings`;
    }

    // User Settings Menu API - V2
    apiGetUserTypeContentTypeLists() {
        return `${this.collabticForumApi}/GetUserTypeContentTypeList`;
    }

    // Notification list
    apiGetConfigNotificationLists() {
        return `${this.collabticV3Api}/notification-config/list`;
    }

    // Notification list
    apiGetEscConfigLists() {
        return `${this.escalationV2Api}/getEscConfig`;
    }

    // Notification list
    apiUpdateEscConfigLists() {
        return `${this.escalationV2Api}/UpdateEscConfig`;
    }

    // Notification Update
    apiUpdateConfigNotification() {
        return `${this.collabticV3Api}/notification-config/update-user-config`;
    }

    // Dispatch Notification Config API
    apiDispatchNotificationConfig() {
        return `${this.collabticV3Api}/notification-config`;
    }

    // Dispatch Notification Update API
    apiDispatchNotificationUpdate() {
        return `${this.collabticV3Api}/notification-config/update`;
    }

    // get domain API
    apiGetAllowedDomains() {
        return `${this.collabticAccountsApi}/getAllowedDomains`;
    }

    // get domain API
    apiUpdateAllowedDomains() {
        return `${this.collabticAccountsApi}/UpdateAllowedDomains`;
    }

    // Make Notification Config API
    apiGetSettingsMakeFilterConfig() {
        return `${this.searchApi}/getSettingsMakeFilter`;
    }

    // Make update Notification Config API
    apiUpdateMakeSettingsFilterV2() {
        return `${this.searchApi}/UpdateMakeSettingsFilterV2`;
    }

    apiGetMarketPlaceShippingCost(domainId) {
        return `${this.collabticLocalhost}/market-place/getshippingcost?domainId=${domainId}`;
    }

    apiGetMarketPlaceEmailNoticationsSettings(domainId) {
        return `${this.collabticLocalhost}/market-place/getemailnotificationsettings?domainId=${domainId}`;
    }

    apiGetMarketPlaceEmailNoticationsSetting(domainId, type) {
        return `${this.collabticLocalhost}/market-place/getemailnotificationsetting?domainId=${domainId}&type=${type}`;
    }

    apiUpdateMarketPlaceEmailNoticationsSettings() {
        return `${this.collabticLocalhost}/market-place/emailnotificationsettingupdate`;
    }

    apiUpdateTextMessageTooltip() {
        return `${this.collabticLocalhost}/market-place/textmessagetooltipupdate`;
    }

    apiUpdateMarketPlaceShippingCost() {
        return `${this.collabticLocalhost}/market-place/shippingcostupdate`;
    }

    // store API
    apiGetStoreInfoList() {
        return `${this.collabticForumApi}/GetStoreInfoList`;
    }

    // getsubscriberslist API
    apiGetSubscribersList() {
        return `${this.collabticDashApi}/getsubscriberslist`;
    }

    // import API
    apiImportStoreList() {
        return `${this.collabticForumApi}/ImportStoreList`;
    }

    // Audit List API
    apiGetAuditList() {
        return `${this.collabticV3Api}/audit/list`;
    }

    // FAQ List API
    apiGetFaqList() {
        return `${this.collabticV3Api}/faq/list`;
    }

    // Manage FAQ API
    apiManageFaq() {
        return `${this.collabticV3Api}/faq/manage`;
    }

    // Get Feedback Fields API
    apiGetFeedbackFields() {
        return `${this.collabticV3Api}/feedback/fields`;
    }

    // Manage FAQ API
    apiManageFeedback() {
        return `${this.collabticV3Api}/feedback/manage`;
    }

    apiManageAudit() {
        return `${this.collabticV3Api}/audit/manage`;
    }

    // Delete ADAS File API
    apiAdasFile() {
        return `${this.collabticV3Api}/adas/manage`;
    }

    // serviceRecords
    apiServiceRecords() {
        return `${this.collabticForumApi}/servicerecordslist`;
    }

    // Customer List API
    apiGetCustomerList() {
        return `${this.collabticV3Api}/shop/customers`;
    }

    // Customer List SOLR API
    apiGetCustomerListSolr() {
        return `${Constant.SolrAPIUrl}/list`;
    }

    // Customer List SOLR Search API
    apiGetCustomerListSolrSearch() {
        return `${Constant.SolrAPIUrl}/search`;
    }

    // Manage Service Notes API
    apiManageServiceNotes() {
        return `${this.collabticV3Api}/services/manage-notes`;
    }

    // Customer Notes API
    apiGetCustomerNotesSave() {
        return `${this.collabticV3Api}/shop/save-customer-notes`;
    }

    // Manage Customer Status API
    apiManageCustomerStatus() {
        return `${this.collabticV3Api}/shop/manage-status`;
    }

    /*** repair order */
    apiChangeStatusTicket() {
        return `${this.collabticLocalhost}/support-tickets/change-work-order-status`;
    }

    apiGetSupportTicketsList() {
        return `${this.collabticLocalhost}/support-tickets/list`;
    }

    apiUpdateSupportTicketsList() {
        return `${this.collabticLocalhost}/support-tickets/manage-work-order`;
    }

    apiDeleteSupportTicketsList() {
        return `${this.collabticLocalhost}/support-tickets/delete-work-order`;
    }

    apiCompleteSupportTicket() {
        return `${this.collabticLocalhost}/support-tickets/complete-work-order`;
    }

    apiWooCompleteSupportTicket() {
        return `${this.collabticLocalhost}/support-tickets/woo-comm-order-details`;
    }

    apiGetJOBDetailsList() {
        return `${this.collabticLocalhost}/support-tickets/job-details-list`;
    }

    apiGetCompaniesList() {
        return `${this.collabticLocalhost}/support-tickets/get-companies`;
    }

    apiManageCompany() {
        return `${this.collabticLocalhost}/support-tickets/manage-company`;
    }

    apiManagejobType() {
        return `${this.collabticLocalhost}/support-tickets/managejobtype`;
    }

    apiGetWorkOrderList() {
        return `${this.collabticLocalhost}/support-tickets/work-order-list`;
    }

    apiUpdateJOBDetailsList() {
        return `${this.collabticLocalhost}/support-tickets/manage-job-details`;
    }

    apiGetRateCardList() {
        return `${this.collabticLocalhost}/support-tickets/rate-card-list`;
    }

    apiUpdatRateCardList() {
        return `${this.collabticLocalhost}/support-tickets/manage-rate-card`;
    }

    manageAdasThirdParty() {
        return `${this.collabticLocalhost}/support-tickets/manageadasthirdparty`;
    }

    chatbotSubmitAdasReport() {
        return `${Constant.chatbotApiUrl}/submit_adas_report`;
    }

    chatbotExtractAdasReport() {
        return `${Constant.chatbotApiUrl}/extract_adas_report`;
    }

    apiSocialAction() {
        return `${this.collabticV3Api}/social-action/manage`;
    }

    uploadExcelFile() {
        return `${this.collabticLocalhost}/excel-sheet/saveexcel`;
    }

    getExcelFile() {
        return `${this.collabticLocalhost}/excel-sheet/getalldata`;
    }

    getExcelFileMasters() {
        return `${this.collabticLocalhost}/excel-sheet/getmasters`;
    }

    updateExcelTableData() {
        return `${this.collabticLocalhost}/excel-sheet/updatemapping`;
    }

    // get automated msg
    apiGetAutomatedMsg() {
        return `${this.collabticApi}/landingpage/ShowSpecialMessage`;
    }

    // re-open thread
    apiUpdateLLM() {
        return `${this.collabticForumApi}/UpdateLangModelThread`;
    }

    apiConvertosharefix() {
        return `${this.collabticLocalhost}/forum/convertosharefix`;
    }

    apiReopenThreadsOption() {
        return `${this.collabticForumApi}/reopenthreadsoption`;
    }

    apiUpdateAI() {
        return `${this.collabticForumApi}/updateaisummarythread`;
    }

    apiManageUserPageActivityAPI() {
        return `${this.collabticV3Api}/user-page-activity/manage`;
    }


    // Update Roles and Permissions
    apiGetZoneList() {
        return `${this.collabticDashApi}/Getzonelist`;
    }

    apiGetSavedCard() {
        return `${this.collabticLocalhost}/market-place/getsavedcard`;
    }

    apiGetQbItems() {
        return `${this.collabticLocalhost}/market-place/getqbitems`;
    }

    apiUpdateQbItemPrice() {
        return `${this.collabticLocalhost}/market-place/updateqbitemprice`;
    }

    apiUpdateQbItemProductCode() {
        return `${this.collabticLocalhost}/market-place/updateqbitemproductcode`;
    }

    apiGetQbItemDetails() {
        return `${this.collabticLocalhost}/market-place/trainingdetails`;
    }

    apiGetSlackChannels(domainId, code, redirectUri) {
        return `${this.collabticLocalhost}/market-place/getslackchannels?domainId=${domainId}&code=${code}&redirectUri=${redirectUri}`;
    }

    apiSetSlackChannels() {
        return `${this.collabticLocalhost}/market-place/setslackchannel`;
    }

    apiRemoveSlackChannel() {
        return `${this.collabticLocalhost}/market-place/removeslackchannel`;
    }

    apiGetSlack() {
        return `${this.collabticLocalhost}/market-place/getslackchannel`;
    }

    uploadReportsPdf() {
        return `${this.collabticLocalhost}/market-place/readpdf`;
    }

    updateTransactionSalesPerson() {
        return `${this.collabticLocalhost}/market-place/updatetransactionsalesperson`;
    }

    resendEmailFromReports() {
        return `${this.collabticLocalhost}/market-place/resendtrainingemail`;
    }

    addTrainingParticipant() {
        return `${this.collabticLocalhost}/market-place/addtrainingparticipant`;
    }

    updateParticipantCompany() {
        return `${this.collabticLocalhost}/market-place/updateparticipantcompany`;
    }

    resendPaymentFromReports() {
        return `${this.collabticLocalhost}/market-place/resendpaymentreceipt`;
    }

    setreminderemailsettings() {
        return `${this.collabticLocalhost}/market-place/setreminderemailsettings`;
    }

    getreminderemailsettings() {
        return `${this.collabticLocalhost}/market-place/getreminderemailsettings`;
    }

    updatetransactionuser() {
        return `${this.collabticLocalhost}/market-place/updatetransactionuser`;
    }

    updatetransactionuserdetail() {
        return `${this.collabticLocalhost}/market-place/updatetransactionuserdetail`;
    }

    getReconciliationReport() {
        return `${this.collabticLocalhost}/market-place/getclasstransactions`;
    }

    // Check RO Contact Exists
    apiCheckROContactExists() {
        return `${this.collabticV3Api}/shop/contact-exist`;
    }

    // Customer Reset Password
    apiCustomerResetPassword() {
        return `${this.collabticV3Api}/shop/customer-reset-password`;
    }

    // Setup Stripe Cards
    apiSetupCard() {
        return `${this.collabticV3Api}/support-tickets/setup-stripe-card`;
    }

    apiUrltobase64() {
        return `${this.collabticV3Api}/market-place/urltobase64`;
    }

    getTrainingParticipant() {
        return `${this.collabticV3Api}/market-place/gettrainingparticipant`;
    }

    manageTransactionCompany() {
        return `${this.collabticV3Api}/market-place/managetransactioncompany`;
    }

    apiAdasrecentlist() {
        return `${this.collabticV3Api}/adas-vehicle/adasrecentlist`;
    }

    apiFindAdasVehicleLocations() {
        return `${this.collabticV3Api}/adas-vehicle/findadasvehiclelocations`;
    }

    apiFindMediaByLocations() {
        return `${this.collabticV3Api}/adas-vehicle/findmediabylocations`;
    }

    apiManageAdditionalSystem() {
        return `${this.collabticV3Api}/adas-vehicle/manage-additional-system`;
    }

    apiVinAutoDataDecode() {
        return `${this.collabticV3Api}/adas-vehicle/vinautodatadecode`;
    }

    apiVehicleSurveyList() {
        return `${this.collabticV3ApiV2}/adas-vehicle/vehiclesurveylist`;
    }

    apiUpdateInspectionSurvey() {
        return `${this.collabticV3Api}/adas-vehicle/updateinspectionsurvey`;
    }

    apiAdasShareReport() {
        return `${this.collabticV3Api}/adas-vehicle/share-report`;
    }

    getdealerempreportapi() {
        return `${this.mahleV2DashApi}/dealerempreportapi`;
    }

    downloaddashreportapi() {
        return `${this.collabticLocalhost}/forum/downloaddashreport`;
    }

    downloaddashweeklyreportapi() {
        return `${this.collabticLocalhost}/forum/excelaereportweekdownload`;
    }

    downloaddashJOBSreportapi() {
        return `${this.collabticLocalhost}/truckinventory/excelforgbbreport`;
    }
    apiInstallerplannedlist() {
        return `${this.collabticLocalhost}/truckinventory/installerplannedlist`
    }
    apiExcelforgbbreportdatalist() {
        return `${this.collabticLocalhost}/truckinventory/excelforgbbreportdata`
    }

    uploadAttachmentForRuntime() {
        let url = Constant.HeadQuarterApiUri;
        return `${url}media/attachmentupload`;
    }

    // announcement dashboard
    apiReadStatus() {
        return `${Constant.HeadQuarterApiUri}announcement/add-announcement-attributes`;
    }

    // diagnostic programming capabilities
    apiGetDiagnosticFieldList() {
        return `${this.collabticV3Api}/diagnostic-programming-capabilities/listinputs`;
    }

    apiGetDiagnosticFieldUpdate() {
        return `${this.collabticV3Api}/diagnostic-programming-capabilities/manageinput`;
    }

    apiDiagnosticlist() {
        return `${this.collabticV3Api}/diagnostic-programming-capabilities/list`;
    }

    apiGetrounprocessedlist() {
        return `${this.collabticV3Api}/support-tickets/getrounprocessedlist`;
    }

    apiGetlogoptionslist() {
        return `${this.collabticV3Api}/network/getlogoptions`;
    }

    apiGetManageContentImportHistory() {
        return `${this.mahleV2Api}/managecontent/getimporthistory`;
    }

    apiGetManageContentDirImportHistory() {
        return `${this.mahleV2Api}/managecontent/getdirectoryimporthistory`;
    }

    apiDeleteManageContentImportHistory() {
        return `${this.mahleV2Api}/managecontent/deleteimporthistory`;
    }


    apiGetManageContentModellist() {
        return `${this.mahleV2Api}/managecontent/getmodellist`;
    }

    apiGetsplashscreenlist() {
        return `${this.mahleV2Api}/managecontent/getsplashscreenlist`;
    }

    apiUploaddealernpsfile() {
        return `${this.mahleV2Api}/managecontent/uploaddealernpsfile`;
    }

    apiUploaddealerdirfile() {
        return `${this.mahleV2Api}/managecontent/uploadtvsdirectory`;
    }

    apiNewImportHistory() {
        return `${this.mahleV2Api}/managecontent/importdealernpsfile`;
    }

    apiNewImportDirHistory() {
        return `${this.mahleV2Api}/managecontent/importtvsdirectoryfile`;
    }

    apiDiagnosticUpdate() {
        return `${this.collabticV3Api}/diagnostic-programming-capabilities/manage`;
    }

    apiDiagnosticDelete() {
        return `${this.collabticV3Api}/diagnostic-programming-capabilities/delete`;
    }

    apiApproveWorkOrder() {
        return `${this.collabticLocalhost}/support-tickets/work-order-approve`;
    }

    apiUpdateEstimateApprove() {
        return `${this.collabticLocalhost}/support-tickets/updateestimateapprove`;
    }

    apiRoAdasMap() {
        return `${this.collabticLocalhost}/support-tickets/maprocalpro`;
    }

    getTaxStates() {
        return `${this.collabticLocalhost}/market-place/gettaxstates`;
    }

    getDataFromUrl() {
        return `${this.collabticLocalhost}/market-place/getdatafromurl`;
    }

    setTaxStates() {
        return `${this.collabticLocalhost}/market-place/settaxstates`;
    }

    updateSalesRep() {
        return `${this.collabticLocalhost}/market-place/updatesalesrep`;
    }

    apiSalesdashboard() {
        return `${this.collabticLocalhost}/shop/salesdashboard`;
    }

    apiSalesType2dashboard() {
        return `${this.collabticLocalhost}/shop/salesdashboardv2`;
    }
    apiCasesPriority() {
        return `${this.collabticLocalhost}/forum/casespriority`;
    }
    apiCaseCustomerPriorites() {
        return `${this.collabticLocalhost}/forum/casecustomerpriorites`;
    }
    apiSalesdashAttribute() {
        return `${this.collabticLocalhost}/shop/salesdashattributes`;
    }

    getAllSubscribersByDomain() {
        return `${this.collabticLocalhost}/market-place/getallsubscribersbydomain`;
    }

    getAllSubscribersDashboard() {
        return `${this.collabticLocalhost}/market-place/getallsubscribersdashboard`;
    }

    revenuePerMonth() {
        return `${this.collabticLocalhost}/market-place/revenuepermonth`;
    }

    classFillRate() {
        return `${this.collabticLocalhost}/market-place/classfillrate`;
    }

    getSalesPerPricingTear() {
        return `${this.collabticLocalhost}/market-place/salesperpricingtear`;
    }

    getTrainingByState() {
        return `${this.collabticLocalhost}/market-place/trainingbystate`;
    }

    trainingFillRate() {
        return `${this.collabticLocalhost}/market-place/trainingfillrate`;
    }

    trainingPerMonth() {
        return `${this.collabticLocalhost}/market-place/trainingpermonth`;
    }

    apiGetLocationData() {
        return `${this.collabticAccountsApiv2}/locationdata`;
    }


  apiUpdatetechthreadstatus(){
    return `${this.collabticAccountsApi}/updatetechthreadstatus`;
  }

  apiGetSalesProfit() {
    //return `${this.collabticV3Api}/support-tickets/getsalesprofit`;
    return `${this.collabticV3Api}/profitmargin/getsalesprofit`;
  }

  apiGetprofithome() {
    //return `${this.collabticV3Api}/support-tickets/getsalesprofit`;
    return `${this.collabticV3Api}/profitmargin/getprofithome`;
  }


  apiGetprofithomedata() {
    //return `${this.collabticV3Api}/support-tickets/getsalesprofit`;
    return `${this.collabticV3Api}/profitmargin/getprofithomedata`;
  }

  apiGetprofitsalesrecapdata() {
    //return `${this.collabticV3Api}/support-tickets/getsalesprofit`;
    return `${this.collabticV3Api}/profitmargin/getprofitsalesrecapdata`;
  }

  apiUpdateSalesProfit() {
    //return `${this.collabticV3Api}/support-tickets/getsalesprofit`;
    return `${this.collabticV3Api}/profitmargin/saveprofiledata`;
  }

  apiSaveprofilehomemonthdata() {
    //return `${this.collabticV3Api}/support-tickets/getsalesprofit`;
    return `${this.collabticV3Api}/profitmargin/saveprofilehomemonthdata`;
  }

  apiExtractVinFromImage() {
    return `${Constant.SolrAPIUrl}/images/extract`;
  }
  apiGetOpenRecalls() {
    return `${this.collabticV3Api}/fixes/getrecalldata`;
  }
  apiGetTsbData() {
    return `${Constant.collabticV3ApiUrl}/all-data/get-tsbs`;
  }
  apiGetRecentVinHistory() {
    return `${Constant.CollabticFixesApiUrl}/vehicle/GetSearchHistory`;
  }
  apiSocialLogin() {
    return `${Constant.CollabticFixesApiUrl}/accounts/socialloginapi`;
  }
  apiSearchHistoryRecommend() {
    return `${Constant.SolrAPIUrl}/search/recommend`;
  }
  apiUploadCsxData() {
    return `${this.collabticV3Api}/profitmargin/uploadprofitfile`;
 }
 apiGetTechJobList() {
    return `${this.collabticV3Api}/support-tickets/tech-job-report`;
 }
 apiGetTechJobUpdate() {
    return `${this.collabticV3Api}/support-tickets/savetechjobsdata`;
 }
 apiProcessThreadExport() {
    return `${this.collabticLocalhost}/forum/processthreadexport`;
 }
 apiSavetechlabordata() {
    return `${this.collabticV3Api}/profitmargin/savetechlabordata`;
 }
 apiSavetechcarddata() {
    return `${this.collabticV3Api}/profitmargin/savetechcarddata`;
 }
 apiSaveprofilehomedata () {
    return `${this.collabticV3Api}/profitmargin/saveprofilehomedata `;
 }
 apiGetROchequelist() {
    return `${this.collabticV3Api}/support-tickets/rochequelist`;
 }
 apiSaveROchequedetails() {
    return `${this.collabticV3Api}/support-tickets/saverochequedetails`;
 }
 apiSaveROCardPayment() {
    return `${this.collabticV3Api}/support-tickets/paymentroprocess`;
 }
 apiRObankslist() {
    return `${this.collabticV3Api}/support-tickets/bankslist`;
 }

 apiSaveRObankName() {
    return `${this.collabticV3Api}/support-tickets/savebankdetails`;
 }

apiSolrImagesExtract() {
    const SolrAPIUrl = Constant.SolrAPIUrl;
      return `${SolrAPIUrl}/images/extract/job`;
  }

  apiCreateDocument() {
    const platformId = localStorage.getItem('platformId')
    if( platformId == '1') {
        return this.collabticApi + `/resources/CreateManualsandAnnouncement`
    }
    return this.collabticApi + `resources/CreateManualsandAnnouncement`
  }

  attachDocUpload() {
    const platformId = localStorage.getItem('platformId')
    if( platformId == '1') {
        return this.collabticApi + `/threadpost/AttachmentUpload`
    }
    return this.collabticApi + `threadpost/AttachmentUpload`
  }

  apiUpdateSolrShopStatus() {
    const platformId = localStorage.getItem('platformId')
    if( platformId == '1') {
        return this.collabticApi + `/forum/UpdateDatetoSolr`
    }
    return this.collabticApi + `forum/UpdateDatetoSolr`
  }

  apiGetInventoryMetrics() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/getinventorymetrics`
  }

  apiGetInventoryMetricsv2() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/getinventorymetricsv2`
  }

  apiGetInventoryQtyDetails() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/inventoryqtydetails`
  }

  apiGetInventoryWarehouseInfo() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/inventorywarehouseinfo`
  }

  apiGetInventoryWarehouseDetails() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/inventorywarehousedetails`
  }

  apiGetInstallerTruckList() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/installerstruckslist`
  }

  apiGetInventoryWarehouseList() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/inventorywarehouselist`
  }

  apiMoveserialnumber() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/moveserialnumber`
  }

  apiMoveserialnumberCore() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/moveserialnumberfromcore`
  }

  apiGetInventoryPartsByWarehouse() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/inventorypartsbywarehouse`
  }
  apiGetInventoryTruckList() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/inventorytrucklist`
  }

  apiSaveserialNoInfo() {
    let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/saveserialnoinfo`
  }

  apiDeleteserialNoInfo() {
    let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/deleteserialno`
  }

  apiImportSerialNumber() {
    let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/uploadpartsinventoryfile`
  }

  apiExportInventory() {
    let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/inventoryserialdownload`
  }

  apiDownloadTemplate() {
    let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/downinventorytemplate`
  }

  apiGetInventoryMasterList() {
    let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/inventorymasterlist`
  }

   apiGetsnofrompartno() {
   let url = Constant.HeadQuarterApiUri;
    return url + `truckinventory/getsnofrompartno`
  }

    apiGetSerialImportHistory() {
        let url = Constant.HeadQuarterApiUri;
        return url + `truckinventory/getinventoryimporthistory`
    }

  apiQBOCheck() {
    return `${this.collabticV3Api}/quick-books-online/connection-verification`;
  }

  apiQBOClientId() {
    return `${this.collabticV3Api}/quick-books-online/get-client-id`;
  }

  apiSetupQBOToken() {
    return `${this.collabticV3Api}/quick-books-online/set-client-tokens`;
  }

  apiDisconnectQBO() {
    return `${this.collabticV3Api}/quick-books-online/revoke-client-tokens`;
  }

  apiGetSessionExcel() {
    return `${this.collabticV3Api}/gts/getsessionsexcel`;
  }

  apiTechniciansWithStatus() {
    return `${this.collabticV3Api}/support-tickets/technicians-with-status`;
  }

  apiManageTechnicianStatus() {
    return `${this.collabticV3Api}/support-tickets/manage-technician-status`;
  }

  apiGetUserShortcuts() {
    return `${this.collabticV3Api}/shop/get-user-shortcuts`;
  }

  apiSetUserShortcut() {
    return `${this.collabticV3Api}/shop/set-user-shortcut`;
  }
  
  apiAssignTech() {
    return `${this.collabticV3Api}/support-tickets/assigntech`;
  }
  
  apiGetTimeZoneByDate() {
    return `${this.collabticV3Api}/support-tickets/timezonebydate`;
  }

  apiGetROTimeLineInfo() {
    return `${this.collabticV3Api}/support-tickets/gettimeline`;
  }

  apiGetROActivityLogInfo() {
    return `${this.collabticV3Api}/support-tickets/getlog`;
  }

  uploadS3() {  
   let platformId = localStorage.getItem("platformId");
   if (platformId == PlatFormType.Collabtic) {
        return `${this.collabticV3Api}/media/getpresignedurl`;
        } else if (platformId == PlatFormType.MahleForum) {
            return `${this.mahleV2Api}/media/getpresignedurl`;
        } else if (platformId == PlatFormType.CbaForum) {
            return `${this.collabticV3Api}/media/getpresignedurl`;
        } 
        else{
            return `${this.collabticV3Api}/media/getpresignedurl`;
        }
    }
    
    uploadS3MultiPart(endpointPath: string) {
        const platformId = localStorage.getItem("platformId") || PlatFormType.Collabtic;
        let baseUrl = '';
        switch (platformId) {
            case PlatFormType.Collabtic:
            case PlatFormType.CbaForum:
                baseUrl = this.collabticV3Api;
                break;
            case PlatFormType.MahleForum:
                baseUrl = this.mahleV2Api;
                break;
            default:
                baseUrl = this.collabticV3Api;
        }
        return `${baseUrl}/media/${endpointPath}`;
      }

    updateThirdPartySettings() {
        return `${this.collabticV3Api}/accounts/updatethirdpartysettings`;
    }
}
